export default {
  // Date formatting
  'date.format': 'dd.MM.yyyy',
  'date.format_datetime': 'dd.MM.yyyy HH:mm',
  'date.format_datetime_long': "EEEE, d. MMMM yyyy 'um' HH:mm 'Uhr'",

  cancel: 'Abbrechen',
  all: 'Alle',
  of: 'von',
  from: 'von',
  to: 'bis',
  is: 'ist',
  count: 'Anzahl',
  spending: 'Ausgaben',
  language: 'Sprache',
  sign_out: 'Abmelden',
  sign_in: 'Anmelden',
  email_address: 'E-Mail-Adresse',
  company_name: 'Unternehmen',
  password: 'Passwort',
  search: 'Suche',
  entries: 'Einträge',
  total_budget: 'Gesamtbudget',
  daily_budget: 'Täglich',
  error: 'Fehler',
  deposit: 'Gutschrift',
  refund: 'Rückerstattung',
  withdraw: 'Belastung',
  amount: 'Betrag',
  description: 'Beschreibung',
  unknown: 'Unbekannt',
  selected: 'Ausgewählt',
  nothing_found: 'Nichts gefunden',
  type_to_search: 'Zum Suchen tippen...',
  'common.network_error': 'Es ist ein Netzwerkfehler aufgetreten. Bitte versuchen Sie es erneut.',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.expired': 'Abgelaufen',
  'common.new': 'Neu',
  'common.choose_company': 'Wählen Sie ein Unternehmen',
  'data.saved': 'Daten wurden erfolgreich gespeichert',
  'data.save_failed': 'Das Speichern der Daten ist fehlgeschlagen: Unbekannter Fehler.',
  'data.upload_failed': 'Datei konnte nicht hochgeladen werden',
  'app.something_wrong': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
  'app.init_loading': 'Anwendung wird vorbereitet',
  'app.init_failure':
    '{app} konnte nicht initialisiert werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.',
  'brand.switcher.badge': 'Nur Test',
  'brand.switcher.hint': 'Testhilfe: nur auf localhost und Stage verfügbar, nie auf Produktion',
  'brand.switcher': 'Marke',
  'auth.tagline': 'Intelligente Stellenanzeigen',
  'auth.welcome_back': 'Willkommen zurück',
  'auth.welcome_subtitle': 'Kampagnen, Werbemittel und Bewerbungen – alles an einem Ort.',
  'auth.work_email': 'Geschäftliche E-Mail-Adresse',
  'auth.keep_signed_in': 'Angemeldet bleiben',
  'auth.invalid_credentials': 'Ungültige Zugangsdaten',
  'auth.new_to_app': 'Noch kein Konto bei {app}?',
  'auth.create_account': 'Konto erstellen',
  'auth.back_to_sign_in': '← Zurück zur Anmeldung',
  'auth.footer.privacy': 'Datenschutzerklärung',
  'auth.footer.terms': 'AGB',
  'auth.footer.imprint': 'Impressum',
  'auth.panel.headline': 'Andere erreichen 15%. {app} erreicht 100%.',
  'auth.panel.headline_hriq': 'Erreichen Sie 100% Ihrer Zielgruppe – nicht nur die 15%, die aktiv suchen.',
  'auth.panel.description':
    'Social Media, Jobportale, beliebte Websites: eine Kampagne für alle Kanäle – ganz ohne Marketing-Know-how.',
  'auth.panel.many_more': 'viele weitere',
  'auth.panel.stat_roles': 'ausgeschriebene Stellen seit 2018',
  'auth.panel.stat_campaigns': 'Kampagnen für Schweizer Arbeitgeber',
  'auth.panel.stat_clicks': 'Klicks auf die Stelleninserate unserer Kunden',
  'login.title': 'Mit Ihrem {app}-Konto anmelden',
  'forgot_password.title': 'Passwort vergessen',
  'reset_password.title': 'Ihr {app}-Passwort zurücksetzen',
  'reset_password.reset_button': 'Zurücksetzungs-E-Mail anfordern',
  'reset_password.email_sent': 'Ein Zurücksetzungslink wurde gesendet, wenn ein Konto mit dieser Adresse verknüpft ist',
  'reset_password.wrong_link': 'Ungültiger Zurücksetzungslink. Bitte versuchen Sie es erneut',
  'login.remember_me': 'Angemeldet bleiben',
  'login.password_placeholder': 'Ihr Passwort',
  'login.no_account': 'Noch kein Konto?',
  'login.sign_up': 'Registrieren',
  'nav.home': 'Startseite',
  'nav.orders': 'Aufträge',
  'nav.active_poolmirror_campaign': 'Portfolio-Kampagne',
  'nav.poolmirror_list': 'Portfolio-Kampagnen',
  'nav.cvanalyzer': 'CV-Assistent',
  'nav.external_job_markets': 'Stellen',
  'home.see_all_orders': 'Alle Aufträge anzeigen',
  'home.see_all_orders_heading': 'Bestehende Aufträge anzeigen',
  'home.see_all_orders_subheading': 'Hier finden Sie alle Ihre bestehenden Aufträge',

  'order_creation.loader.content.title': 'Daten werden geladen',
  'order_creation.loader.content.subtitle': 'Bitte warten Sie, während wir die notwendigen Informationen laden.',
  // Order Creation Initial Step
  'order_creation.initial_step.main_heading': 'Wo sollen Kandidaten hingeführt werden?',
  'order_creation.initial_step.main_description':
    'Hast du bereits ein Online-Inserat? Wir können auch eines für dich erstellen – entweder auf Basis eines Dokuments oder einer bestehenden Website.',
  'order_creation.initial_step.option_direct_url_title': 'Direct-URL',
  'order_creation.initial_step.option_direct_url_description': 'Ihre Online URL',
  'order_creation.initial_step.option_file_import_title': 'Datei-import',
  'order_creation.initial_step.option_file_import_description': 'PDF / DOCX',
  'order_creation.initial_step.option_web_import_title': 'Web-Import',
  'order_creation.initial_step.option_web_import_description': 'von URL',
  'order_creation.initial_step.option_custom_title': 'Custom',
  'order_creation.initial_step.option_custom_description': 'Inserat gestalten',
  'order_creation.initial_step.lead_funnel_tooltip': 'Lead Funnel möglich',
  'order_creation.initial_step.direct_url_section_heading': 'Direkt-URL',
  'order_creation.initial_step.direct_url_section_description':
    'Du hast bereits ein Online-Inserat / eine Webseite, auf die die Kandidaten direkt weitergeleitet werden sollen.',
  'order_creation.initial_step.job_url_label': 'URL der Online-Stellenanzeige',
  'order_creation.initial_step.job_url_placeholder': 'example.com',
  'order_creation.initial_step.application_form_link': 'Link zum Bewerbungsformular?',
  'order_creation.initial_step.apply_url_label': 'Bewerbungs-URL',
  'order_creation.initial_step.apply_url_hint':
    'Wohin sollen Bewerber weitergeleitet werden, wenn auf den "Jetzt bewerben"-Button geklickt wird?',
  'order_creation.initial_step.no_apply_url_tooltip': 'Kein Bewerbungs-URL',
  'order_creation.initial_step.file_import_section_heading': 'Datei-import',
  'order_creation.initial_step.file_import_section_description':
    'Lade ein PDF oder eine DOCX Dokument hoch von welchem der inhalt importiert werden soll.',
  'order_creation.initial_step.file_upload_text': 'Datei Hochladen',
  'order_creation.initial_step.web_import_section_heading': 'Web-Import',
  'order_creation.initial_step.web_import_section_description':
    'Wir erstellen ein neues Online-Inserat auf Basis eines Bestehenden. Das erlaubt dir z. B., ein Funnel-Inserat zu erstellen.',
  'order_creation.initial_step.custom_section_heading': 'Custom',
  'order_creation.initial_step.custom_section_description': 'Erstelle ein neues Inserat mit unserem Editor.',
  'order_creation.initial_step.content_generation_switch_label': 'Beispiel Inhalt generieren',
  'order_creation.initial_step.content_generation_switch_description':
    'Wir generieren auf Basis der Eckdaten der Stelle ein initiales Stelleninserat für dich.',

  // Order Creation Import Step
  'order_creation.import_step.processing_title': 'Inhalt wird verarbeitet',
  'order_creation.import_step.processing_description':
    'Dein Inhalt wird gerade importiert und strukturiert. Das kann ein paar Minuten dauern. Wir bitten um Geduld.',
  'order_creation.import_step.direct_link_failed': 'Beim Verarbeiten des Links ist ein Fehler aufgetreten',
  'order_creation.import_step.processing_failed':
    'Etwas ist beim Verarbeiten schiefgelaufen. Bitte geben Sie die Daten manuell ein oder versuchen Sie es erneut.',

  // Order Creation Job Details Step
  'order_creation.details_step.main_heading': 'Stellendetails',
  'order_creation.details_step.description': 'Bitte überprüfen Sie die Eckdaten der zu bewerbenden Stelle.',
  'order_creation.details_step.basic_heading': 'Basis',
  'order_creation.details_step.job_title': 'Stellentitel',
  'order_creation.details_step.job_title_placeholder': 'z.B. Senior Marketing Manager',
  'order_creation.details_step.job_title_hint': 'Der volle Stellentitel, <b>ohne</b> Firma oder Arbeitsort.',
  'order_creation.details_step.workload': 'Teilzeit Pensum',
  'order_creation.details_step.full_time': 'Vollzeit',
  'order_creation.details_step.part_time': 'Teilzeit',
  'order_creation.details_step.permanent_employment': 'Festanstellung',
  'order_creation.details_step.temporary_employment': 'Temporär',
  'order_creation.details_step.permanent_employment_description':
    'Handelt es sich um eine Festanstellung (unbefristetes Arbeitsverhältnis)?',
  'order_creation.details_step.temporary_employment_description': 'Es handelt sich um eine temporäre Anstellung?',
  'order_creation.details_step.company_heading': 'Unternehmen',
  'order_creation.details_step.company_title': 'Firma',
  'order_creation.details_step.company_placeholder': 'Wählen Sie ein Unternehmen',
  'order_creation.details_step.location_title': 'Arbeitsort',
  'order_creation.details_step.address': 'Adresse / Ortschaft',
  'order_creation.details_step.use_company_address': 'Von Unternehmen übernehmen',
  'order_creation.details_step.location_hint':
    'Wenn aktiviert, wird der Unternehmensstandort als Arbeitsort verwendet.',
  'order_creation.details_step.job_title_required': 'Stellentitel ist erforderlich.',
  'order_creation.details_step.workload_min_must_be_smaller_or_equal_max':
    'Das Mindestpensum muss kleiner oder gleich dem Höchstpensum sein.',
  'order_creation.details_step.company_required': 'Bitte wählen Sie ein Unternehmen aus.',
  'order_creation.details_step.upload_logo': 'Logo hochladen',
  'order_creation.details_step.remove_logo': 'Logo entfernen',
  'order_creation.details_step.address_required': 'Bitte geben Sie einen Arbeitsort an.',
  'order_creation.details_step.no_active_budget_title': 'Kein aktives Budget',
  'order_creation.details_step.no_active_budget_description':
    'Sie haben derzeit kein aktives Budget, daher kann kein neuer Auftrag erstellt werden. Bitte wenden Sie sich an den Support, um ein Budget einzurichten.',

  // Order Creation Media Step
  'order_creation.media_step.main_heading': 'Bildmaterial',
  'order_creation.media_step.description':
    'Welches Bildmaterial soll für die Stellenanzeige sowie die Werbemittel verwendet werden?',
  'order_creation.media_step.for_this_order': 'Für diesen Auftrag',
  'order_creation.media_step.upload_image': 'Bild hochladen',
  'order_creation.media_step.uploading': 'Wird hochgeladen…',
  'order_creation.media_step.imported_from_source': 'Importiert von Quelle',
  'order_creation.media_step.imported_from_source_desc':
    'Bilder, die im Zusammenhang mit deiner Quelle gefunden wurden.',
  'order_creation.media_step.imported_from_source_loading': 'Bilder werden gesucht...',
  'order_creation.media_step.imported_from_source_empty': 'Für Ihre Quelle wurden keine Bilder gefunden.',
  'order_creation.media_step.imported_from_source_error':
    'Bilder für Ihre Quelle konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  'order_creation.media_step.company_images': 'Firmenbilder',
  'order_creation.media_step.company_images_desc':
    'Bilder, die mit dem von dir ausgewählten Unternehmen in Verbindung stehen.',
  'order_creation.media_step.add': 'Hinzufügen',
  'order_creation.media_step.ai_media': 'AI Bildmaterial',
  'order_creation.media_step.ai_media_desc':
    'Kein passendes Bildmaterial? Wir generieren dir auf diese Stelle zugeschnittenes Bildmaterial.',
  'order_creation.media_step.generate_more': 'mehr Generieren',
  'order_creation.media_step.focus_update_success': 'Fokuspunkt aktualisiert',
  'order_creation.media_step.focus_update_failed':
    'Fokuspunkt konnte nicht aktualisiert werden. Bitte versuche es erneut.',

  // Order Creation Publication Steps
  'order_creation.publication_type.title': 'Publikationstyp',
  'order_creation.publication_type.subtitle': 'Welche Art von Publikation möchtest du erstellen?',
  'order_creation.publication_type.online.title': 'Bewerbungsformular',
  'order_creation.publication_type.online.hint': 'Formular mit Lebenslauf-Upload',
  'order_creation.publication_type.settings': 'Funnel erstellung',
  'order_creation.publication_type.settings_hint': 'Bitte wählen Sie die gewünschten Funnel-Optionen aus.',
  'order_creation.publication_type.content_settings': 'Inhaltseinstellungen',
  'order_creation.publication_type.content_settings_hint': 'Bitte wählen Sie die gewünschten Inhaltsoptionen aus.',
  'order_creation.publication_type.optimize_title': 'Inhalt für Funnel Optimieren',
  'order_creation.publication_type.optimize_hint':
    'Wir können den Inhalt deines Inserats automatisch für eine Funnel- oder Lead-Kampagne für dich umschreiben.',
  'order_creation.publication_type.optimize_content_title': 'Inhalt optimieren',
  'order_creation.publication_type.optimize_content_hint':
    'Wir können den Inhalt deines Inserats automatisch für dich umschreiben und verbessern.',
  'order_creation.publication_type.questions_title': 'Qualifikationsfragen generieren',
  'order_creation.publication_type.questions_hint':
    'Wir generieren dir 3–4 Qualifikationsfragen auf Basis deines Stelleninserats. Zum Beispiel: Wenn eine Anforderung ein Führerausweis einer bestimmten Kategorie ist, kann das hier automatisch abgefragt werden.',
  'order_creation.publication_type.contact.title': 'Kontakt',
  'order_creation.publication_type.contact.subtitle':
    'Wer soll E-Mail-Benachrichtigungen zu neuen Bewerbungen / Kontaktaufnahmen erhalten?',
  'order_creation.publication_type.contact.label': 'Bewerbungskontakt',
  'order_creation.publication_type.contact.placeholder': 'Benutzer auswählen',

  // Order Creation Publication Template Steps
  'order_creation.publication_template.title': 'Publikations template',
  'order_creation.publication_template.subtitle': 'Wie soll die Online-Publikation aussehen?',
  'order_creation.publication_template.loading.title': 'Publikation wird erstellt',
  'order_creation.publication_template.loading.subtitle':
    'Bitte hab einen Moment Geduld, deine Publikation wird gerade erstellt.',
  'order_creation.publication_template.no_templates.title': 'Keine Vorlagen verfügbar',
  'order_creation.publication_template.no_templates.subtitle':
    'Für diesen Auftrag sind keine Publikationsvorlagen verfügbar. Bitte kontaktiere den Support, um fortzufahren.',

  // Order Creation Final Review Step
  'order_creation.final_review.title': 'Ihr Auftrag',
  'order_creation.final_review.subtitle':
    'Es ist nun alles ready für deinen Auftrag,  du kannst diesen entweder sofort bestätigen oder einen link generieren überwelchen eine bestätigung eingeholt werden kann.',
  'order_creation.final_review.basic_data': 'Basisdaten',
  'order_creation.final_review.online_link': 'Link zum Online-Insert',
  'order_creation.final_review.advertising_preview': 'Werbemittel Vorschau',
  'order_creation.final_review.products': 'Produkte',
  'order_creation.final_review.start_button': 'Auftrag Starten',
  'order_creation.final_review.confirm_now.title': 'Jetzt Bestätigen',
  'order_creation.final_review.confirm_now.subtitle': 'Der Auftrag geht sofort in Verarbeitung.',
  'order_creation.final_review.confirm_external.title': 'Externe Bestätigung',
  'order_creation.final_review.confirm_external.subtitle': 'Einen Link zur Bestätigung generieren.',
  'order_creation.final_review.reference_comment.title': 'Referenz & Kommentar',
  'order_creation.final_review.reference_comment.ref_number_label': 'Referenznummer (optional)',
  'order_creation.final_review.reference_comment.ref_number_hint':
    'Eine Referenz zur Identifikation des Auftrags, z. B. aus Ihrem internen System.',
  'order_creation.final_review.reference_comment.comment_label': 'Kommentar (optional)',
  'order_creation.final_review.reference_comment.comment_hint':
    'Wünsche oder zusätzliche Informationen an unser Campaigning-Team.',

  // Order Creation Self Service Step
  'order_creation.loader.stage.banners': 'Banner',
  // shown while job.generate_banners is still running — campaign generation is queued behind it
  'order_creation.loader.banners.1.title': 'Ihre Banner werden gestaltet',
  'order_creation.loader.banners.1.subtitle': 'Jedes Pixel an seinen Platz.',
  'order_creation.loader.banners.2.title': 'Die Video-Banner werden gerendert',
  'order_creation.loader.banners.2.subtitle': 'Das ist der langsame, schöne Teil.',
  'order_creation.loader.banners.3.title': 'Die passenden Bildausschnitte werden gewählt',
  'order_creation.loader.banners.3.subtitle': 'Abgeschnittene Titel mag niemand.',
  'order_creation.loader.banners.4.title': 'Die Motive sind fast fertig',
  'order_creation.loader.banners.4.subtitle': 'Als Nächstes folgen die Kampagnen.',
  'order_creation.loader.campaigns.1.title': 'Kampagnen werden hochgefahren',
  'order_creation.loader.campaigns.1.subtitle': 'Die Zahnräder drehen sich.',
  'order_creation.loader.campaigns.2.title': 'Die Ad-Engines laufen warm',
  'order_creation.loader.campaigns.2.subtitle': 'Nach einem Moment laufen sie runder.',
  'order_creation.loader.campaigns.3.title': 'Der digitale rote Teppich wird ausgerollt',
  'order_creation.loader.campaigns.3.subtitle': 'Ihre Kampagnen verdienen einen würdigen Auftritt.',
  'order_creation.loader.campaigns.4.title': 'Die Kampagnen werden in Form gebracht',
  'order_creation.loader.campaigns.4.subtitle': 'Sie können überraschend schüchtern sein.',
  'order_creation.loader.campaigns.5.title': 'Die Werbetafeln werden ausgerollt',
  'order_creation.loader.campaigns.5.subtitle': 'Natürlich nur im übertragenen Sinne.',
  'order_creation.loader.campaigns.6.title': 'Den Algorithmen werden Manieren beigebracht',
  'order_creation.loader.campaigns.6.subtitle': 'Meistens hören sie zu.',
  'order_creation.loader.campaigns.7.title': 'Die Banner werden poliert',
  'order_creation.loader.campaigns.7.subtitle': 'Ein bisschen Glanz wirkt Wunder.',

  'home.see_all_poolmirror': 'Zur Kampagne',
  'home.see_all_poolmirror_heading': 'Ihre Portfolio-Kampagne',
  'home.see_all_poolmirror_subheading': 'Ihr Portfolio-Slot-Abo mit Auslastung und Kampagnen auf einen Blick.',
  'home.create_order': 'Neuen Auftrag erstellen',
  'home.create_order_heading': 'Neuen Auftrag erstellen?',
  'home.create_order_subheading': 'Geben Sie Ihrer Stellenanzeige einen Boost.',
  'order_creation_blocked.title': 'Sie können noch keinen Auftrag erstellen',
  'order_creation_blocked.body':
    'Bei der Einrichtung Ihres Kontos ist leider etwas schiefgelaufen, weshalb aktuell keine Kampagnen erstellt werden können. Kontaktieren Sie den Support, wir kümmern uns umgehend darum.',
  'portfolio.list_poolmirror': 'Portfolio-Kampagnen',
  'portfolio.crawled_jobs': 'Erfasste Jobs',
  'portfolio.campaign_slots': 'Kampagnen-Slots',
  'portfolio.slot_usage': 'Slot-Auslastung',
  'portfolio.subscription': 'Abonnement',
  'portfolio.subscription_ends_in': 'Endet',
  'portfolio.subscription_ended': 'Abgelaufen',
  'portfolio.available_jobs': 'Verfügbare Stellenanzeigen',
  'portfolio.show_all_slots': 'Alle Slots anzeigen',
  'portfolio.job_search_placeholder': '"/" um nach Stellen zu suchen',
  'search.generic_placeholder': 'Drücken Sie "/" um zu suchen',
  'orders.search_placeholder': 'Aufträge, Auftrags-IDs, Unternehmen suchen...',
  'cvanalyzer.list.title': 'Analysierte Lebensläufe',
  'is_loading.generic': 'Daten werden geladen...',
  'sort.direction': 'Sortierungsrichtung',
  'sort.field.created_at': 'Erstellungsdatum',
  'sort.field.relevance': 'Relevanz',
  'orders.list.sort.title': 'Auftragstitel',
  'orders.list.column.order': 'Auftrag',
  'orders.list.column.runtime': 'Laufzeit',
  'orders.list.column.budget': 'Budget',
  'orders.grid.last_7_days': 'Letzte 7 Tage',
  'orders.grid.clicks_ctr': 'Klicks · CTR',
  'orders.details.open': 'Öffnen',
  'btn.more': 'Mehr',
  'orders.layout.list': 'Liste',
  'orders.layout.grid': 'Raster',
  'orders.list.title': 'Aufträge',
  'orders.list.subtitle.singular': 'Auftrag',
  'orders.list.subtitle.plural': 'Aufträge',
  'orders.list.loading': 'Ihre Aufträge werden geladen..',
  'orders.list.filter_label': 'Filter',
  'orders.list.filter_all': 'Alle',
  'orders.list.filter_active': 'Aktive',
  'orders.list.filter_drafts': 'Entwürfe',
  'orders.list.filter_past': 'Vergangene Aufträge',
  'orders.list.filter_my': 'Meine',
  'orders.list.empty': 'Es wurden keine Aufträge gefunden',
  'orders.list.empty.hint': 'Versuchen Sie, Ihre Suche oder Filter anzupassen, um das Gewünschte zu finden.',
  'orders.list.empty.active.title': 'Noch keine aktiven Aufträge',
  'orders.list.empty.active.body':
    'Ihre nächste Einstellung ist nur einen Auftrag entfernt. Starten Sie einen neuen oder öffnen Sie einen Entwurf bzw. vergangenen Auftrag unter „Alle".',
  'orders.list.empty.active.go_to_all': 'Zu „Alle"',
  'orders.create': 'Auftrag erstellen',
  'orders.create.empty.header': 'Zugriff verweigert',
  'orders.create.empty.title': 'Ups... Sie haben keinen Zugriff auf diese Funktion',
  'orders.create.empty.subtitle': 'Wenden Sie sich an Ihren Administrator, um Zugriff auf diese Funktion zu erhalten.',
  'orders.create_button': 'Auftrag erstellen',
  'orders.list.total_clicks': 'Klicks',
  'orders.list.impressions': 'Impressionen',
  'orders.list.days': 'Tage',
  'orders.list.worldwide': 'Weltweit',
  'orders.pagination.page': 'Seite',
  'orders.pagination.prev': 'Vorherige',
  'orders.pagination.next': 'Nächste',
  'pagination.of': 'von',
  'pagination.nav': 'Seitennavigation',
  'pagination.first': 'Erste Seite',
  'pagination.prev': 'Vorherige Seite',
  'pagination.next': 'Nächste Seite',
  'pagination.last': 'Letzte Seite',
  'orders.filters.list_style': 'Listenstil',
  'orders.filters.time_range': 'Zeitbereich',
  'orders.filters.company_name': 'Unternehmen',
  'orders.filters.creator': 'Ersteller',
  'orders.filters.location': 'Arbeitsort',
  'orders.filters.language': 'Sprache',
  'language.de': 'Deutsch',
  'language.en': 'Englisch',
  'language.fr': 'Französisch',
  'language.it': 'Italienisch',
  'orders.filters.reset_filters': 'Zurücksetzen',
  'orders.filters.apply': 'Anwenden',

  'orders.filters.everything': 'Alles',
  'orders.filters.today': 'Heute',
  'orders.filters.thisWeek': 'Diese Woche',
  'orders.filters.thisMonth': 'Diesen Monat',
  'orders.filters.thisYear': 'Dieses Jahr',
  'orders.filters.last7': 'Letzte 7 Tage',
  'orders.filters.last30': 'Letzte 30 Tage',
  'orders.filters.last90': 'Letzte 90 Tage',

  'btn.close': 'Schließen',
  'btn.cancel': 'Abbrechen',
  'btn.confirm': 'Bestätigen',
  'btn.confirmed': 'Bestätigt',
  'btn.continue': 'Weiter',
  'btn.save': 'Speichern',
  'btn.save_and_continue': 'Speichern & Fortsetzen',
  'btn.add': 'Hinzufügen',
  'btn.back': 'Zurück',
  'btn.delete': 'Löschen',
  'btn.edit': 'Bearbeiten',
  'btn.synchronize': 'Synchronisieren',
  'btn.add_location': 'Ort hinzufügen',
  'btn.generate_link': 'Link generieren',
  'btn.add_more': 'Weitere hinzufügen',
  'btn.select': 'Hinzufügen',
  'app.saving': 'Speichern...',
  'app.saved': 'Gespeichert',
  'app.save_error': 'Fehler beim Speichern',
  'app.unsaved_changes': 'Es gibt ungespeicherte Änderungen',
  'app.all_changes_saved': 'Alle Änderungen gespeichert',
  'common.message': 'Nachricht',
  'common.step': 'Schritt',
  'common.of': 'von',
  'common.close': 'Schliessen',
  'customer.cards.settings.title': 'Box-Einstellungen',
  'customer.cards.settings.metric_label': 'Metrik',
  'customer.cards.settings.metric_placeholder': 'Bitte auswählen...',
  'common.comment': 'Kommentar',
  'common.done': 'Fertig',
  'common.workspace': 'Arbeitsbereich',
  'common.company': 'Unternehmen',
  'common.title': 'Titel',
  'common.job': 'Job',
  'common.dates': 'Daten',
  'common.duration': 'Dauer',
  'common.impressions': 'Impressionen',
  'common.clicks': 'Klicks',
  'datepicker.startdate': 'Startdatum',
  'datepicker.select_start': 'Kampagnenbeginn auswählen',
  'datepicker.date_help': 'Bitte definieren Sie die Laufzeit Ihrer Kampagne.',
  'datepicker.date_help.only_start': 'Bitte geben Sie an, wann die Kampagne beginnen soll',
  'datepicker.days': 'Tage',
  'datepicker.infinite_duration': 'Unbegrenzt',
  'dropzone.drop_browse': 'Dateien ablegen oder durchsuchen',
  'dropzone.drop_msg': 'Dateien ablegen',

  'campaigns.manual.location_limit_reached': 'Entfernen Sie einen Standort, um einen anderen hinzuzufügen.',
  'campaigns.manual.add_address': 'Weitere Adresse hinzufügen',
  'campaigns.manual.search_address': 'Nach einer Adresse suchen',
  'campaigns.manual.max_file_size': 'max. {size} KB',
  'campaigns.status.new': 'Neu',
  'campaigns.status.confirmed': 'Bestätigt',
  'campaigns.status.sync': 'Synchronisieren',
  'campaigns.status.active': 'Aktiv',
  'campaigns.status.paused': 'Pausiert',
  'campaigns.status.error': 'Fehler',
  'campaigns.status.finished': 'Beendet',
  'campaigns.please_select': 'Bitte auswählen...',
  'campaigns.please_write': 'Bitte eingeben...',
  'campaigns.no_campaigns': 'Es sind noch keine Kampagnen für diesen Auftrag vorhanden.',
  'campaigns.contact_support': 'Bitte kontaktieren Sie unseren Support für weitere Informationen.',
  'campaigns.self_service.continue_blocked_incomplete':
    'Sie können noch nicht fortfahren. Bitte füllen Sie alle Pflichtfelder aus und speichern Sie jede Karte aller Kampagnen.',
  'campaigns.self_service.continue_blocked_contact_support':
    'Alle Kampagnenkarten sind gespeichert, der Auftrag kann dennoch nicht fortgesetzt werden. Bitte kontaktieren Sie unseren Support.',
  'campaigns.no_banners_found': 'Keine Banner für diesen Auftrag gefunden',
  'campaigns.click_to_upload': 'Klicken zum Hochladen des Bildes',
  'campaigns.choose_image': 'Bild auswählen',
  'campaigns.choose_video': 'Video auswählen',
  'campaigns.media.video_banner': 'Video-Banner',
  'campaigns.media.video_processing': 'Das Video wird noch verarbeitet und es ist noch keine Vorschau verfügbar',
  'campaigns.media.video_failed': 'Das Video konnte nicht verarbeitet werden',
  'campaigns.media.banner_processing': 'Banner wird verarbeitet',
  'campaigns.media.banner_failed': 'Banner konnte nicht gerendert werden',
  'campaigns.please_fill_in': 'Bitte füllen Sie alle Felder aus, bevor Sie speichern.',
  'campaigns.please_select_location': 'Bitte wählen Sie einen Standort aus...',
  'campaign.error_saving':
    'Beim Speichern der aktualisierten Felder ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'campaigns.adform.remove_creative': 'Kreative entfernen',
  'campaigns.linkedin.linkedin_job_advertisement': 'LinkedIn-Stellenanzeige',
  'campaigns.linkedin.linkedin_description': `Veröffentlichen Sie Ihre Stellenanzeige auf LinkedIn, der weltweit größten beruflichen Netzwerkplattform. Erreichen Sie qualifizierte Fachkräfte und steigern Sie die Sichtbarkeit Ihrer Jobangebote durch gezieltes Recruiting.`,
  'campaigns.linkedin.open_in_linkedin': 'Auf LinkedIn öffnen',
  'campaigns.linkedin.linkedin_profile_hint':
    'Bitte wählen Sie das LinkedIn-Unternehmensprofil, auf dem dieser Job veröffentlicht werden soll.',
  'campaigns.linkedin.linkedin_profile_description': 'Wählen Sie die LinkedIn-Unternehmensseite für diesen Job aus',
  'campaigns.linkedin.error_saving_page':
    'Beim Speichern der LinkedIn-Unternehmensseite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'campaigns.linkedin.please_select_location': 'Wählen Sie den Standort aus, an dem der Job angesiedelt ist.',
  'campaigns.linkedin.error_saving_location':
    'Beim Speichern des LinkedIn-Standorts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'campaigns.linkedin.terms_and_conditions': 'Allgemeine Geschäftsbedingungen',
  'campaigns.linkedin.i_agree': 'Ich stimme zu',
  'campaigns.linkedin.terms_and_conditions_part': 'den allgemeinen Geschäftsbedingungen',
  'campaigns.linkedin.terms_and_conditions_error':
    'Sie müssen den allgemeinen Geschäftsbedingungen zustimmen, um fortzufahren.',
  'campaigns.facebook.no_fb_pages_message':
    'Es sind keine Facebook-Seiten eingerichtet. Bitte gehen Sie zu Einstellungen -> Verbundene soziale Netzwerke, um Ihre Facebook-Seite zu verbinden.',
  'campaigns.facebook.facebook_ad_story_error':
    'Sie haben vergessen, ein Bild für Ihr Story-Format auszuwählen. Bitte wählen Sie ein Bild aus oder entfernen Sie die Story-Format-Platzierung.',
  'campaigns.facebook.select_facebook_page_first': 'Wählen Sie zuerst die Facebook-Seite aus',
  'campaigns.facebook.failed_retrieving_targeting_data':
    'Fehler beim Abrufen der Targeting-Daten. Bitte versuchen Sie es später erneut.',
  'campaigns.facebook.location_targeting': 'Standort-Targeting',
  'campaigns.facebook.add_location': 'Ort hinzufügen',
  'campaigns.facebook.loading': 'Lädt...',
  'campaigns.facebook.choose_country': 'Wählen Sie ein Land aus',
  'campaigns.facebook.choose_location': 'Wählen Sie einen Ort aus',
  'campaigns.facebook.radius_tooltip': 'Optional: Zwischen 17 und 80 (Kilometer)',
  'campaigns.facebook.targeting_level_label': 'Targeting-Ebene',
  'campaigns.facebook.targeting_level_country': 'Land',
  'campaigns.facebook.targeting_level_location': 'Stadt / Region',
  'campaigns.facebook.primary_texts': 'Primärtexte',
  'campaigns.facebook.add_primary_text': 'Primärtext hinzufügen',
  'campaigns.facebook.image_selection': 'Bildauswahl',
  'campaigns.facebook.toast_info': `Denken Sie daran, dass Änderungen an Ihren Facebook-Anzeigen einige Minuten dauern können, bis sie in Ihrem Facebook-Werbekonto sichtbar sind.`,
  'campaigns.facebook.remove_portrait_format': 'Porträtformat entfernen',
  'campaigns.google_ads.location': 'Standort',
  'campaigns.google_ads.headlines': 'Überschriften',
  'campaigns.google_ads.descriptions': 'Beschreibungen',
  'campaigns.google_ads.headline_count': '{current} / {max} Überschriften',
  'campaigns.google_ads.description_count': '{current} / {max} Beschreibungen',
  'campaigns.google_ads.logo_image': 'Logo-Bild',
  'campaigns.google_ads.marketing_images': 'Marketing-Bilder',
  'campaigns.google_ads.images_used': 'bilder verwendet',
  'campaigns.google_ads.radius': 'Radius',
  'campaigns.tiktok.ad_text': 'Anzeigentext',
  'campaigns.tiktok.video': 'Video',
  'campaigns.tiktok.select_video': 'Video auswählen',
  'campaigns.tiktok.interest_categories_placeholder': 'Interessenkategorien auswählen',
  'campaigns.tiktok.remove_ad': 'Anzeige entfernen',

  'orders.create.wizard': 'Assistent',
  'orders.create.form.disabled': 'Bitte geben Sie die URL Ihrer Stellenanzeige ein.',
  'orders.create.full_form': 'Vollständiges Formular',
  'orders.create.btn': 'Auftrag erstellen',
  'orders.create.title_create': 'Neuen Auftrag erstellen',
  'orders.create.title_modify': 'Auftrag ändern und neu erstellen',
  'orders.create.title_confirm': 'Bitte bestätigen Sie den Auftrag',
  'orders.wizard.intro.heading': 'Hallo',
  'orders.wizard.intro.subheading':
    'Lassen Sie mich Ihnen bei der Konfiguration Ihrer programmatischen Kampagne helfen. Ich lerne noch, aber ich werde versuchen, Ihnen beim Zusammenstellen der erforderlichen Daten zu helfen.',
  'orders.wizard.intro.job_posting': 'Ihre Stellenanzeige',
  'orders.wizard.steps.apply_link': 'Eigener Bewerbungslink?',
  'orders.wizard.steps.url': 'URL der Online-Stellenanzeige',
  'orders.wizard.steps.apply_url': 'Bewerbungs-URL',
  'orders.wizard.intro.new_posting_title': 'Oder neue Anzeige',
  'orders.wizard.intro.new_posting_description':
    'Wenn Sie über keinen Link zu einer Online-Stellenanzeige verfügen, können Sie auch eine über {app} erstellen. Sie können z. B. ein PDF oder Word-Dokument hochladen.',
  'orders.wizard.intro.new_posting_button': 'Online-Stellenanzeige erstellen',
  'orders.wizard.intro.url_help': 'Die Seite hinter dieser URL sollte ausschließlich die Stellenanzeige enthalten.',
  'orders.wizard.intro.url_enter': 'Geben Sie die URL Ihrer Stellenanzeige ein.',
  'orders.wizard.intro.apply_url_enter': 'Geben Sie die Bewerbungs-URL ein.',
  'orders.wizard.intro.apply_url_help':
    'Wohin sollen Bewerber weitergeleitet werden, wenn auf den "Jetzt bewerben"-Button geklickt wird?',

  'orders.wizard.products.title': 'Produktauswahl',
  'orders.wizard.products.loading_budget': 'Budget wird geladen...',
  'orders.wizard.products.loading_budget.description': 'Bitte warten Sie, während wir das verfügbare Budget laden.',
  'orders.wizard.products.no_products': 'Keine Produkte verfügbar',
  'orders.wizard.products.no_products.description':
    'Sie können nicht fortfahren, ohne mindestens ein Produkt auszuwählen. Wenden Sie sich an Ihre Kontaktperson.',
  'orders.wizard.products.products': 'Produkte',
  'orders.wizard.products.product': 'Produkt',

  'orders.wizard.platforms.title': 'Plattformauswahl',
  'orders.wizard.platforms.subtitle':
    'Wo sollen wir Ihre Stellenanzeige veröffentlichen? Bitte wählen Sie die Plattformen, die Sie nutzen möchten.',
  'orders.wizard.platforms.platforms': 'Plattformen',

  'orders.wizard.analytics.title': 'Stellenanalyse',
  'orders.wizard.analytics.subtitle':
    'Wir analysieren derzeit Ihre Online-Stellenanzeige. Dies kann einige Sekunden dauern...',
  'orders.wizard.analytics.subtitle_completed': 'Stellenanzeige wurde erfolgreich analysiert.',
  'orders.wizard.analytics.campaign_duration': 'Kampagnendauer',
  'orders.wizard.analytics.campaign_budget': 'Kampagnenbudget',
  'orders.wizard.analytics.document_open': 'Dokument wird geöffnet',
  'orders.wizard.analytics.validating_format': 'Dokumentformat wird überprüft...',
  'orders.wizard.analytics.extracting_metadata': 'Metadaten werden extrahiert...',
  'orders.wizard.analytics.parsing_content': 'Inhalt wird analysiert...',
  'orders.wizard.analytics.identifying_job_title': 'Stellenbezeichnung wird ermittelt...',
  'orders.wizard.analytics.extracting_workload': 'Arbeitsumfang wird extrahiert...',
  'orders.wizard.analytics.detecting_workplace': 'Arbeitsort wird erkannt...',
  'orders.wizard.analytics.analyzing_requirements': 'Anforderungen werden analysiert...',
  'orders.wizard.analytics.extracting_responsibilities': 'Aufgaben werden extrahiert...',
  'orders.wizard.analytics.formatting_publication': 'Stellenanzeige wird formatiert...',
  'orders.wizard.analytics.optimizing_output': 'Ausgabe wird optimiert...',
  'orders.wizard.analytics.finalizing_publication': 'Stellenanzeige wird finalisiert...',

  'orders.wizard.analytics.total_budget': 'Gesamtbudget',
  'orders.wizard.analytics.daily': 'Täglich',
  'orders.wizard.analytics.budget_help':
    'Bitte definieren Sie das Budget Ihrer Kampagne. Das minimale Budget beträgt CHF 123 bei einer Laufzeit von 30 Tagen.',
  'orders.wizard.analytics.analyzing': 'Analysieren',
  'orders.wizard.analytics.crawling': 'Stellenanzeige wird abgerufen',
  'orders.wizard.analytics.connecting': 'Verbindung wird hergestellt',
  'orders.wizard.analytics.failed_to_retrieve': 'Konnte nicht abgerufen werden',

  'orders.wizard.details.title': 'Stellendetails',
  'orders.wizard.details.subtitle': 'Bitte überprüfen und vervollständigen Sie die Details Ihrer Anzeige.',
  'orders.wizard.details.job_title': 'Stellenbezeichnung / Position',
  'orders.wizard.details.job_title_help':
    'Geben Sie die Stellenbezeichnung ein, idealerweise kurz und prägnant, ohne Pensumangabe (80% etc.).',
  'orders.wizard.details.company_name': 'Unternehmensname',
  'orders.wizard.details.company_name_help': 'Der Name des einstellenden Unternehmens. Dies wird öffentlich angezeigt.',
  'orders.wizard.details.workload_min': 'Mindestpensum',
  'orders.wizard.details.workload_max': 'Höchstpensum',
  'orders.wizard.details.location': 'Arbeitsort',
  'orders.wizard.details.location_help':
    'Der Standort des Arbeitsplatzes. Dies wird öffentlich angezeigt und in einigen Fällen für Geotargeting verwendet.',

  'orders.wizard.media.title': 'Medien',
  'orders.wizard.media.subtitle': 'Optional: Laden Sie Ihr Firmenlogo für diesen Auftrag hoch',
  'orders.wizard.media.images_subtitle': 'Optional: Laden Sie zusätzliche Bilder für diesen Auftrag hoch',
  'orders.wizard.media.company_logo': 'Firmenlogo',
  'orders.wizard.media.order_images': 'Bilder',
  'orders.wizard.media.use_logo_future': 'Bild künftig wiederverwenden',

  'orders.wizard.remarks.title': 'Bemerkungen',
  'orders.wizard.remarks.subtitle':
    'Darf ich Ihnen bei der Erstellung Ihres Auftrags helfen? Ich lerne zwar noch, werde aber mein Bestes geben, Sie bei der Zusammenstellung der Kampagne zu unterstützen.',
  'orders.wizard.remarks.msg_placeholder': 'Bitte teilen Sie uns mit...',

  'publication.editor.title': 'Inserat bearbeiten',
  'publication.editor.tabs.meta': 'Meta',
  'publication.editor.tabs.template': 'Vorlage',
  'publication.editor.tabs.settings': 'Einstellungen',
  'publication.editor.tabs.form': 'Formular',
  'publication.editor.tabs.questions': 'Fragen',
  'publication.editor.meta.name': 'Name',
  'publication.editor.meta.active': 'Aktiv',
  'publication.editor.meta.active.hint': 'Inserat ist öffentlich zugänglich',
  'publication.editor.meta.template': 'Vorlage',
  'publication.editor.meta.variation': 'Variante',
  'publication.editor.meta.pubkey': 'Pubkey',
  'publication.editor.meta.created': 'Erstellt',
  'publication.editor.meta.updated': 'Zuletzt aktualisiert',
  'publication.editor.meta.open_public_url': 'Öffentliche URL öffnen',
  'publication.editor.update_success': 'Inserat wurde aktualisiert',
  'publication.editor.update_failed': 'Aktualisierung des Inserats fehlgeschlagen',
  'publication.editor.template': 'Aktuelle Vorlage',
  'publication.editor.template.hint':
    'Wählen Sie eine Vorlage, die für die Zielgruppe Ihrer Stelle am besten geeignet ist, um optimale Ergebnisse zu erzielen. Denken Sie daran, dass bei einer Änderung der Vorlage alle Einstellungen zurückgesetzt werden, der Inhalt jedoch unberührt bleibt.',
  'publication.editor.contact_method': 'Kontaktmethode für Kandidaten',
  'publication.editor.contact_method.description':
    'Legen Sie fest, welche Kontaktdaten Kandidaten angeben und bestätigen müssen.',
  'publication.editor.contact_method.email': 'Nur E-Mail',
  'publication.editor.contact_method.phone': 'Nur Telefon',
  'publication.editor.contact_method.both': 'E-Mail und Telefon',
  'publication.editor.no_settings': 'Keine Einstellungen gefunden',

  // template adjustments (gespeicherte, wiederverwendbare Werte)
  'publication.editor.adjustments.save_title': 'Diese Einstellungen zur Wiederverwendung speichern?',
  'publication.editor.adjustments.save_description':
    'Wählen Sie, welche Einstellungen als Vorgabe für künftige Publikationen übernommen werden sollen.',
  'publication.editor.adjustments.persist_all': 'Alle künftigen Publikationen',
  'publication.editor.adjustments.persist_once': 'Nur dieses Mal',
  'publication.editor.adjustments.select_all': 'Alle auswählen',
  'publication.editor.adjustments.deselect_all': 'Alle abwählen',
  'publication.editor.adjustments.close': 'Schließen',
  'publication.editor.adjustments.name_label': 'Name',
  // {n} wird durch die nächste freie Nummer ersetzt; der Platzhalter zeigt den Namen einer unbenannten Vorgabe
  'publication.editor.adjustments.default_name': 'Vorgabe {n}',
  'publication.editor.adjustments.name_optional_hint':
    'Optional — leer lassen, um den vorgeschlagenen Namen zu verwenden.',
  'publication.editor.adjustments.save_and_continue': 'Speichern & weiter',
  'publication.editor.adjustments.continue_without_saving': 'Ohne Speichern fortfahren',
  'publication.editor.adjustments.save_success': 'Vorgabe gespeichert.',
  'publication.editor.adjustments.save_error': 'Die Vorgabe konnte nicht gespeichert werden.',
  'publication.editor.adjustments.load_title': 'Gespeicherte Einstellungen laden?',
  'publication.editor.adjustments.load_description':
    'Wir haben gespeicherte Einstellungen für dieses Unternehmen gefunden. Eine davon als Ausgangspunkt laden?',
  'publication.editor.adjustments.load_description_single':
    'Wir haben eine gespeicherte Vorgabe für dieses Unternehmen gefunden. Als Ausgangspunkt laden?',
  'publication.editor.adjustments.load': 'Laden',
  'publication.editor.adjustments.start_from_defaults': 'Mit Vorgabewerten beginnen',
  'publication.editor.adjustments.preview_title': 'Werte, die übernommen werden',
  'publication.editor.adjustments.no_value': '(leer)',
  'publication.editor.adjustments.value_yes': 'Ja',
  'publication.editor.adjustments.value_no': 'Nein',
  'publication.editor.adjustments.delete_confirm_title': 'Gespeicherte Vorgabe löschen?',
  'publication.editor.adjustments.delete_confirm_description':
    'Damit wird die gespeicherte Vorgabe entfernt. Bereits damit erstellte Publikationen sind nicht betroffen.',
  'publication.editor.adjustments.load_success': 'Gespeicherte Einstellungen übernommen.',
  'publication.editor.adjustments.delete_success': 'Vorgabe gelöscht.',
  'publication.editor.adjustments.delete_error': 'Die Vorgabe konnte nicht gelöscht werden.',
  'publication.editor.resize': 'Zum Ändern der Größe ziehen',
  'publication.editor.device.label': 'Vorschaugerät',
  'publication.editor.device.mobile': 'Mobil',
  'publication.editor.device.tablet': 'Tablet',
  'publication.editor.device.desktop': 'Desktop',
  'publication.editor.mode.label': 'Ansicht',
  'publication.editor.fullscreen.label': 'Vollbild',
  'publication.editor.fullscreen.open': 'Vollbildvorschau öffnen',
  'publication.editor.fullscreen.close': 'Vollbildvorschau schliessen',
  'publication.editor.save_failed': 'Speichern fehlgeschlagen',
  'publication.editor.saved': 'Gespeichert',
  'publication.editor.transforming_content': 'Inhalt wird vorbereitet…',
  'publication.editor.optimizing_content': 'Inhalt wird generiert…',
  'publication.editor.mode.editor': 'Editor',
  'publication.editor.mode.preview': 'Vorschau',
  'publication.editor.preview_button': 'Vorschau',
  'publication.editor.select_placeholder': 'Auswählen...',
  'publication.editor.please_select': 'Bitte auswählen...',
  'publication.editor.items': 'Einträge',
  'publication.editor.item': 'Eintrag',
  'publication.editor.add_item': 'Eintrag hinzufügen',
  'publication.editor.no_items': 'Noch keine Einträge hinzugefügt.',
  'publication.editor.no_items_hint':
    'Noch keine Einträge hinzugefügt. Klicken Sie zum Starten auf „Eintrag hinzufügen“.',
  'publication.editor.image.change': 'Ändern',
  'publication.editor.image.clear': 'Entfernen',
  'publication.editor.image.invalid_file': 'Bitte wählen Sie eine gültige Bilddatei aus.',
  'publication.editor.image.too_large': 'Das Bild ist zu groß. Die maximale Größe beträgt 10 MB.',
  'publication.editor.image.missing_hash': 'Der Upload war erfolgreich, aber es wurde kein Bild-Hash zurückgegeben.',
  'publication.editor.image.upload_failed': 'Das Bild konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
  'publication.editor.image.company_images': 'Firmenbilder',
  'publication.editor.image.no_company_images': 'Für diesen Auftrag sind keine Firmenbilder verfügbar.',
  'publication.editor.image.upload': 'Hochladen oder aus Bibliothek wählen',
  'publication.editor.email_role_badge.label': 'Wird auch für E-Mails verwendet',
  'publication.editor.email_role_badge.tooltip':
    'Dies wird auch als {role} in der Bewerbungsbestätigungs-E-Mail verwendet.',
  'publication.editor.email_role_badge.role.header': 'Header-Bild',
  'publication.editor.email_role_badge.role.logo': 'Logo',
  'publication.editor.email_role_badge.role.accent': 'Akzentfarbe',
  'publication.editor.template_changed_success': 'Vorlage erfolgreich geändert',
  'publication.editor.template_change_failed': 'Änderung der Vorlage fehlgeschlagen',
  'publication.editor.change_template.title': 'Vorlage ändern',
  'publication.editor.change_template.description':
    'Durch das Ändern der Vorlage werden alle Einstellungen zurückgesetzt, der Inhalt bleibt unberührt. Diese Aktion kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?',

  'form.questions.title': 'Qualifikationsfragen',
  'form.questions.description': 'Legen Sie fest, was Kandidaten bei der Bewerbung beantworten.',
  'form.questions.add_new': 'Frage hinzufügen',
  'form.questions.loading': 'Fragen werden geladen...',
  'form.questions.empty_title': 'Was möchten Sie wissen?',
  'form.questions.empty_description': 'Fügen Sie eine Frage zu Erfahrung, Fähigkeiten oder Verfügbarkeit hinzu.',
  'form.questions.reorder_hint': 'Am Griff ziehen, um Fragen umzuordnen.',
  'form.questions.edit_description': 'Formulieren Sie Ihre Frage und wählen Sie, wie Kandidaten antworten.',
  'form.questions.save_question': 'Frage speichern',
  'form.questions.generate_answers': 'Antworten mit KI vorschlagen',
  'form.questions.ai_hint':
    'Optional. Schlägt anhand Ihrer Frage ein Antwortformat und Inhalte vor. Ersetzt die bisherigen Antwortentwürfe.',
  'form.questions.title_placeholder': 'z.B. Wie viel Berufserfahrung haben Sie?',
  'form.questions.title_required': 'Bitte geben Sie eine Frage ein.',
  'form.questions.answer_type': 'Antworttyp',
  'form.questions.type_single_hint': 'Kandidaten wählen genau eine Antwort.',
  'form.questions.type_multiple_hint': 'Kandidaten können mehrere Antworten wählen.',
  'form.questions.type_text_hint': 'Kandidaten antworten in eigenen Worten.',
  'form.questions.answer': 'Antwort',
  'form.questions.remove_answer': 'Antwort entfernen',
  'form.questions.cancel': 'Abbrechen',
  'form.questions.load_error': 'Fehler beim Laden der Fragen.',
  'form.questions.reorder_success': 'Reihenfolge gespeichert.',
  'form.questions.reorder_failed': 'Fehler beim Speichern der Reihenfolge.',
  'form.questions.saved': 'Frage gespeichert.',
  'form.questions.created': 'Frage erstellt.',
  'form.questions.save_failed': 'Fehler beim Speichern der Frage.',
  'form.questions.deleted': 'Frage gelöscht.',
  'form.questions.delete_failed': 'Fehler beim Löschen der Frage.',
  'form.questions.question_title': 'Frage',
  'form.questions.question_text': 'Beschreibung (optional)',
  'form.questions.answers': 'Antwortmöglichkeiten',
  'form.questions.add_answer': 'Antwort hinzufügen',
  'form.questions.type_multiple': 'Mehrfachauswahl',
  'form.questions.type_single': 'Einzelauswahl',
  'form.questions.type_text': 'Freitext',
  'form.questions.dropdown_hint': 'Die Frage als Dropdown darstellen.',
  'form.questions.free_text': 'Freitextantwort',
  'form.questions.no_answers': 'Keine Antworten definiert',
  'form.questions.new_question': 'Neue Frage erstellen',
  'form.questions.edit_question': 'Frage bearbeiten',
  'form.questions.delete_question': 'Frage löschen',
  'form.questions.delete_confirmation_1': 'Möchten Sie diese Frage wirklich löschen: ',
  'form.questions.delete_confirmation_2': '? Alle zugehörigen Antworten werden ebenfalls gelöscht.',
  'form.questions.ai_prompt_required': 'Bitte geben Sie einen Namen ein, damit die KI eine Frage generieren kann.',
  'form.questions.ai_generation_failed': 'Die KI konnte keine Frage generieren.',

  'publication.status.waiting': 'Warten',
  'publication.status.success': 'Alles OK',
  'publication.status.critical': 'Kritisches Problem',
  'publication.status.logical': 'Logisches Problem',
  'publication.status.unknown': 'Unbekannt',
  'publication.slot.free': 'Freier Slot',
  'publication.no_results': 'Keine Ergebnisse gefunden',
  'publication.no_results.hint':
    'Versuchen Sie, Ihre Suche oder Ihren Filter anzupassen, um herauszufinden, wonach Sie suchen.',
  'publication.publisher_backend': 'Publisher-Backend',
  'publication.last_crawled': 'Zuletzt gecrawlt',
  'publication.show_more': 'Mehr anzeigen',
  'publication.jobiq.deactivate': '{product} deaktivieren',
  'publication.jobiq.activate': '{product} aktivieren',

  'orders.create.form.ref_number': 'Referenz Nr.',
  'orders.create.form.ref_number_help':
    'Das ist die Referenznummer in Ihrem System. Wird automatisch generiert, wenn das Feld leer gelassen wird.',
  'orders.create.form.images_empty': 'Auftrag enthält keine Bilder',
  'orders.create.form.products_empty': 'Für diesen Auftrag wurden keine Produkte ausgewählt',
  'orders.create.form.save_confirm': 'Speichern & Bestätigen',
  'orders.create.form.publish_tooltip':
    'Synchronisation blockiert: Eine oder mehrere Kampagnen fehlen erforderliche Felder. Bitte vervollständigen Sie alle erforderlichen Daten, bevor Sie synchronisieren.',
  'orders.create.form.publish_tooltip_unconfirmed':
    'Synchronisation blockiert: Warten auf Kundenbestätigung, bevor Kampagnen veröffentlicht werden können.',
  'orders.create.form.publish_tooltip_linkedin':
    'Alles ist bereit. LinkedIn kann nur synchronisiert werden, wenn das Startdatum der Kampagne ({date}) dem heutigen Tag entspricht.',
  'orders.create.form.publish': 'Publizieren',
  'orders.confirmation.title': 'Bitte bestätigen Sie den Auftrag',

  'orders.details.title': 'Auftragsdetails',
  'orders.details.clicks': 'Klicks',
  'orders.details.impressions': 'Impressionen',
  'orders.details.cost_per_click': 'Kosten pro Klick',
  'orders.details.cpc_waiting': 'Warten auf weitere Daten',
  'orders.details.total_cost': 'Gesamtkosten',
  'orders.details.better_than_yesterday': 'Besser als gestern',
  'orders.details.worse_than_yesterday': 'Schlechter als gestern',
  'orders.details.remarks.empty': 'Es gibt keine Bemerkungen zu diesem Auftrag',
  'orders.details.previews.empty': 'Für diesen Auftrag sind keine Vorschauen vorhanden.',
  'orders.details.channels': 'Produkte / Kanäle',
  'orders.details.settings': 'Einstellungen',
  'orders.details.info': 'Info',
  'orders.details.preview': 'Vorschau',
  'orders.details.packages': 'Pakete',
  'orders.details.support': 'Support',
  'orders.details.banners': 'Banner',
  'orders.details.banners.empty': 'Keine Banner für diesen Auftrag gefunden',
  'orders.details.banners.not_editable': 'Dieses Banner ist nicht bearbeitbar - von unserem Team für Sie erstellt',
  'orders.details.job_posting': 'Stellenanzeige',
  'orders.details.kanban': 'Kandidaten',
  'orders.details.kanban.no_swimlanes': 'Für dieses Board sind noch keine Spalten konfiguriert.',
  'orders.details.kanban.empty_lane': 'Keine Kandidaten',
  'orders.details.kanban.has_more': 'Weitere Kandidaten nicht angezeigt',
  'orders.details.kanban.unnamed_candidate': 'Unbenannter Kandidat',
  'orders.details.kanban.card_detail': 'Kartendetails',
  'orders.details.kanban.density.s': 'S',
  'orders.details.kanban.density.m': 'M',
  'orders.details.kanban.search_placeholder': 'Kandidaten suchen…',
  'orders.details.kanban.move_error': 'Kandidat(en) konnten nicht verschoben werden. Bitte erneut versuchen.',
  'orders.details.kanban.load_error': 'Das Kandidaten-Board konnte nicht geladen werden. Bitte erneut versuchen.',
  'orders.details.kanban.collapse': 'Einklappen',
  'orders.details.kanban.expand': 'Ausklappen',
  'orders.details.channels.empty': 'Keine Kanäle für diesen Auftrag gefunden',
  'orders.details.delete_order.title': 'Diesen Auftrag löschen?',
  'orders.details.delete_order.description':
    'Sind Sie sicher, dass Sie diesen Auftrag löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'orders.details.delete_order.error': 'Der Auftrag konnte nicht gelöscht werden.',

  'orders.details.delete_campaigns': 'Auftrag löschen',
  'orders.details.finish_campaigns': 'Kampagnen beenden',
  'orders.details.finish_campaigns.description':
    'Möchten Sie die Kampagnen dieses Auftrags wirklich abschließen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'orders.details.finish_campaigns.success': 'Der Prozess zur Beendigung der Kampagnen wurde erfolgreich gestartet',

  'orders.details.open_directlink.tooltip': 'Direktlink öffnen',
  'orders.details.stats': 'Statistiken',
  'orders.stats.overview': 'Übersicht',
  'orders.stats.campaigns': 'Kampagnen',
  'orders.stats.by_provider': 'Nach Anbieter',
  'orders.stats.by_campaign': 'Nach Kampagne',
  'orders.stats.no_data': 'Noch keine Statistiken verfügbar',
  'orders.stats.avg': 'Ø',
  'orders.stats.metric.clicks': 'Klicks',
  'orders.stats.metric.impressions': 'Impressionen',
  'orders.stats.metric.ctr': 'CTR',
  'orders.stats.metric.reach': 'Reichweite',
  'orders.stats.metric.outbound_clicks': 'Ausgehende Klicks',
  'orders.stats.metric.conversions': 'Conversions',
  'orders.stats.metric.applications': 'Bewerbungen',
  'orders.stats.cost': 'Kosten',
  'orders.stats.progress': 'Fortschritt',
  'orders.stats.spend_of': 'Ausgaben von',
  'orders.stats.days_left_of': '{0} Tage übrig von {1}',
  'orders.stats.clicks_incremental': 'Klicks kumuliert',
  'orders.stats.provider_breakdown': 'Anbieter-Aufschlüsselung',
  'orders.stats.metric.t10': 'Qualitätsklicks (T ≥ 10)',
  'orders.stats.metric.t30': 'Qualitätsklicks (T ≥ 30)',
  'orders.stats.metric.t60': 'Qualitätsklicks (T ≥ 60)',
  'orders.stats.metric.t120': 'Qualitätsklicks (T ≥ 120)',
  'orders.stats.finished': 'Abgeschlossen',
  'orders.stats.metric_explorer': 'Metrik-Explorer',
  'orders.stats.explorer.provider': 'Anbieter',
  'orders.stats.explorer.metric': 'Metrik',
  'orders.stats.explorer.view': 'Ansicht',
  'orders.stats.explorer.all_providers': 'Alle Anbieter',
  'orders.stats.explorer.daily': 'Täglich',
  'orders.stats.explorer.cumulative': 'Kumuliert',
  'orders.stats.explorer.compare': 'Vergleich',
  'orders.stats.explorer.total': 'Gesamt',
  'orders.stats.explorer.daily_avg': 'Tages-Ø',
  'orders.stats.explorer.share': 'Anteil',
  'orders.stats.explorer.breakdown': 'Aufschlüsselung',
  'orders.stats.explorer.no_breakdown': 'Keine',
  'orders.stats.breakdown.age': 'Alter',
  'orders.stats.breakdown.gender': 'Geschlecht',
  'orders.stats.breakdown.device': 'Gerät',
  'orders.stats.breakdown.region': 'Region',
  'orders.stats.breakdown.platform': 'Plattform',
  'orders.stats.breakdown.country': 'Land',
  'orders.stats.breakdown.publisher': 'Publisher',

  'orders.preview_modal.tooltip': 'Vorschau-Link generieren',
  'orders.preview_modal.title': 'Anzeigenvorschauen auswählen',
  'orders.preview_modal.preview_link_generated': 'Vorschau-Link generiert.',
  'orders.preview_modal.ad_previews': 'Anzeigenvorschauen',
  'orders.preview_modal.no_previews': 'Für diesen Auftrag sind keine Vorschauen verfügbar.',
  'orders.preview_modal.share_instruction':
    'Wählen Sie die Anzeigen aus, für welche Sie einen öffentlichen Link generieren möchten.',
  'orders.oreview_modal.generated_link_instruction':
    'Ihr öffentlicher Vorschau-Link wurde erfolgreich erstellt. Sie können diesen Link nun teilen, um die ausgewählten Anzeigenvorschauen zu präsentieren.',

  'nav.promptsuite': 'RecruitingIQ',
  'promptsuite.apps.title': '{filter}-Apps',
  'promptsuite.apps.subtitle': 'Verfügbare KI-Apps',
  'promptsuite.show_advanced_options': 'Erweiterte Optionen anzeigen',
  'promptsuite.additional_user_instructions': 'Zusätzliche Anweisungen',
  'promptsuite.additional_user_instructions_placeholder':
    'Beispiel: Schreibe es so einfach, dass es ein 4-jähriges Kind verstehen könnte.',
  'promptsuite.additional_user_instructions.hint':
    'Hier können Sie zusätzliche Anweisungen angeben, denen die KI beim Erstellen des Texts folgen soll.',
  'promptsuite.generate': 'Generieren',
  'promptsuite.sidebar.title': 'Eingabe',
  'promptsuite.sidebar.language': 'Sprache',

  'promptsuite.apps.filter.all': 'Alle',
  'promptsuite.apps.filter.jobposting': 'Stellenanzeige',
  'promptsuite.apps.filter.socialmedia': 'Soziale Medien',
  'promptsuite.apps.filter.activesourcing': 'Active Sourcing',
  'promptsuite.apps.filter.interview': 'Interview',
  'promptsuite.apps.filter.personnelconsultant': 'Personaldienstleister',
  'promptsuite.apps.filter': 'Filter',
  'promptsuite.empty_hint': 'Bitte füllen Sie rechts Ihre Informationen aus.',
  'promptsuite.welcome.title': 'Willkommen bei RecruitingIQ',
  'promptsuite.welcome.subtitle': 'Startseite',
  'promptsuite.welcome.button_to_apps': 'Direkt zu den Apps',

  'promptsuite.linkedinsearch.additional_skills': 'Zusätzliche Fähigkeiten',
  'promptsuite.linkedinsearch.additional_skills.placeholder': 'Beispiel: Salesforce, CRM, Verkaufslösungen',

  'promptsuite.linkedinsearch.additional_tasks': 'Zusätzliche Aufgaben',
  'promptsuite.linkedinsearch.additional_tasks.placeholder': 'Beispiel: Lead-Generierung, Kundenakquise',

  'promptsuite.linkedinsearch.other_titles': 'Zusätzliche Stellentitel',
  'promptsuite.linkedinsearch.other_titles.placeholder': 'Beispiel: Verkaufsleiter, Verkaufsvertreter',

  'promptsuite.linkedinsearch.exclude': 'Auszuschließende Stellentitel, Fähigkeiten, Aufgaben und Schlüsselwörter',
  'promptsuite.linkedinsearch.exclude.placeholder': 'Beispiel: Call Center, Kundenservice',

  'promptsuite.linkedinsearch.open_in_linkedin': 'In LinkedIn öffnen',

  'promptsuite.feedback.title': 'Rückmeldung',
  'promptsuite.feedback.subtitle': `Ihr Feedback ist uns wichtig. Wenn Sie Probleme mit der App oder dem von ihr erstellten Inhalt hatten, teilen Sie bitte Ihre Erfahrungen mit, damit wir unseren Service verbessern können.`,
  'promptsuite.feedback.message': 'Bitte beschreiben Sie Ihre Erfahrung...',
  'promptsuite.feedback.send': 'Feedback senden',
  'promptsuite.feedback.cancel': 'Abbrechen',
  'promptsuite.feedback.thank_you': 'Vielen Dank für Ihr Feedback!',

  'eula.accept': 'EULA akzeptieren',
  temperature: 'Temperatur',
  'temperature.p1':
    'Der Temperaturparameter steuert die Zufälligkeit oder Kreativität der Ausgabe des Modells. Es handelt sich um einen Hyperparameter, der die Wahrscheinlichkeitsverteilung der vom Modell generierten Token (Wörter oder Zeichen) beeinflusst.',
  'temperature.p2':
    'Ein höherer Temperaturwert (z.B. 1,0 oder höher) führt dazu, dass das Modell vielfältigere und kreativere Antworten erzeugt, jedoch mit dem Risiko, weniger kohärent oder genau zu sein. Ein niedrigerer Temperaturwert (z.B. 0,1 oder darunter) führt dazu, dass das Modell konzentriertere, konservativere und deterministischere Ausgaben erzeugt, die eng an die Muster angelehnt sind, die es während seiner Schulung gesehen hat.',
  'template.hint':
    'Die Vorlage verändert den Schreibstil der Stellenanzeige. Wählen Sie eine Vorlage, die am besten zu Ihrer Zielgruppe passt, um optimale Ergebnisse zu erzielen.',

  'settings.accounts.title': 'Konten / User',
  'settings.accounts.subtitle': 'Einstellungen / Konten',
  'settings.accounts.description': 'Erstellen und verwalten Sie Ihre Konten',

  'settings.companies.title': 'Firmen',
  'settings.companies.subtitle': 'Einstellungen / Firmen',
  'settings.companies.description': 'Erstellen und verwalten Sie Ihre Unternehmen',
  'settings.companies.profile_tab': 'Profil',
  'settings.companies.media_tab': 'Bilder & Medien',

  'settings.sub_budgets.title': 'Sub-Budgets',
  'settings.sub_budgets.description': 'Erstellen und verwalten Sie Ihre Sub-Budgets',

  'settings.linked_networks.title': 'Verknüpfte soziale Netzwerke',
  'settings.linked_networks.description': 'Erstellen und verwalten Sie Ihre sozialen Netzwerke',
  'settings.swimlanes.title': 'Kandidaten-Board',
  'settings.swimlanes.subtitle': 'Erstellen und verwalten Sie Ihr Kandidaten-Board',
  'settings.swimlanes.description': 'Konfigurieren Sie die Spalten des Kandidaten-Boards für Ihr Team.',
  'settings.swimlanes.system': 'System',
  'settings.swimlanes.hidden': 'Versteckt',
  'settings.swimlanes.system_locked': 'System-Swimlane — feste Position, kann nicht umbenannt oder entfernt werden',
  'settings.swimlanes.candidate_count': '{count} Kandidaten',
  'settings.swimlanes.rename': 'Umbenennen',
  'settings.swimlanes.reorder': '{name} zum Neuordnen ziehen',
  'settings.swimlanes.delete_has_candidates': 'Eine Swimlane mit Kandidaten kann nicht gelöscht werden',
  'settings.swimlanes.add_placeholder': 'Name der neuen Swimlane',
  'settings.swimlanes.add_button': 'Swimlane hinzufügen',
  'settings.swimlanes.delete_title': 'Diese Swimlane löschen?',
  'settings.swimlanes.delete_text': 'Möchten Sie die Swimlane "{name}" wirklich löschen?',
  'settings.linked_networks.facebook.button': 'Verknüpfen Sie eine Facebook-Seite',
  'settings.linked_networks.facebook.auth_modal.title': 'Verknüpfung Ihrer Facebook-Seiten',
  'settings.linked_networks.facebook.auth_modal.processing': 'Verarbeitung der Facebook-Verknüpfungsdaten...',
  'settings.linked_networks.facebook.auth_modal.pages_connected': 'Facebook-Seite erfolgreich verknüpft!',
  'settings.linked_networks.facebook.auth_modal.error':
    'Beim Verknüpfen der Facebook-Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'settings.linked_networks.no_networks': 'Keine verknüpften sozialen Netzwerke gefunden',
  'settings.linked_networks.delete_facebook.title': 'Verknüpfung der Facebook-Seite löschen',
  'settings.linked_networks.delete_facebook.description':
    'Sind Sie sicher, dass Sie diese Verknüpfung zur Facebook-Seite löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'settings.linked_networks.facebook.note_title': 'Hinweis',
  'settings.linked_networks.facebook.note':
    'Ihre Seiten werden 10-20 Minuten nach Ihrer Genehmigung der Anfragen auf unserer Seite erscheinen',
  'settings.linked_networks.facebook.business_settings': 'Facebook-Unternehmenseinstellungen',

  'settings.companies.error_selecting_company': 'Bei der Auswahl des Unternehmens ist ein Fehler aufgetreten',
  'settings.companies.error_fetching_images': 'Fehler beim Abrufen der Firmenbilder',
  'settings.companies.error_images_update_failed': 'Aktualisierung der Firmenbilder fehlgeschlagen',

  'settings.company.details': 'Firmendetails',
  'settings.company.name': 'Firmenname',
  'settings.company.name.hint': 'Der volle Name des Unternehmens inkl. Rechtsform.',
  'settings.company.display_name': 'Anzeigename',
  'settings.company.display_name.hint': 'Der Name, der zur Darstellung verwendet werden soll.',
  'settings.company.hierarchy': 'Hierarchie',
  'settings.company.parent': 'Übergeordnetes Unternehmen',
  'settings.company.parent.hint': 'Wählen Sie das übergeordnete Unternehmen',
  'settings.company.company_level': 'Hierarchieebene',
  'settings.company.company_level.hint':
    'Wie das aktuelle Unternehmen in Relation zu seinem übergeordneten Unternehmen steht.',
  'settings.company.address': 'Firmenanschrift',
  'settings.company.address.street': 'Straße',
  'settings.company.address.street.hint': 'Die juristische Adresse des Unternehmens.',
  'settings.company.address.city': 'Stadt',
  'settings.company.address.city.hint': 'Die Stadt des Firmensitzes.',
  'settings.company.web_links': 'Web & Links',
  'settings.company.web_links.homepage': 'Homepage',
  'settings.company.web_links.homepage.hint': 'Die Firmenhomepage',

  'settings.company.media.upload_logo': 'Laden Sie ein Firmenlogo hoch',
  'settings.company.media.upload_logo.hint':
    'Fügen Sie Ihr Logo hinzu, um Ihr Unternehmensprofil individuell zu gestalten. Verwenden Sie idealerweise eine hochauflösende PNG- oder SVG-Datei.',
  'settings.company.media.company_images': 'Allgemeine Unternehmensbilder',
  'settings.company.media.company_images.hint':
    'Fügen Sie Bilder hinzu, die Ihr Unternehmen repräsentieren – ideal für Werbung, Stellenanzeigen und Ihre öffentliche Präsenz.',

  'settings.company.orders.no_orders': 'Es wurden keine Aufträge gefunden',
  'settings.company.orders.no_orders.hint': 'Sie können neue Aufträge auf der Seite Aufträge erstellen.',
  'settings.company.orders.job_title': 'Stellentitel',
  'settings.company.orders.created_at': 'Erstellungsdatum',

  'company.images': 'Firmenbilder',
  'company.images.title': 'Firmenbilder',
  'company.images.logo.title': 'Firmenlogo',
  'company.images.logo.subtitle': 'Laden Sie optional Medien für dieses Unternehmen hoch',
  'company.images.media.title': 'Unternehmensmedien',
  'company.images.media.subtitle': 'Laden Sie optional Medien für dieses Unternehmen hoch',
  'company.images.media.success_update_message': 'Firmenbilder aktualisiert',
  'company.details': 'Firmendetails',
  'company.profile': 'Profil',
  'company.details.personal_details': 'Unternehmensdaten',
  'company.details.name': 'Firmenname',
  'company.details.homepage': 'Firmenhomepage',
  'company.details.address': 'Adresse',
  'company.details.address_street': 'Straße',
  'company.details.address_city': 'Ort',
  'company.details.address_zip': 'PLZ',
  'company.details.address_country': 'Land',
  'company.create.button': 'Unternehmen erstellen',
  'company.save.button': 'Unternehmen speichern',

  'nav.settings': 'Einstellungen',
  'settings.title': 'Einstellungen',
  'settings.subtitle': 'Einstellungen / Übersicht',
  'settings.all_settings': 'Alle Einstellungen',

  'nav.account': 'Konto',
  'account.settings': 'Kontoeinstellungen',
  'account.create.button': 'Konto erstellen',

  'account.profile': 'Profil',
  'account.profile.save': 'Konto speichern',
  'account.profile.personal_details': 'Persönliche Details',
  'account.profile.firstname': 'Vorname',
  'account.profile.lastname': 'Nachname',
  'account.profile.email': 'E-Mail-Adresse',
  'account.profile.email_help':
    'Dies ist die E-Mail-Adresse, die Sie zum Anmelden verwenden und über die wir Sie kontaktieren werden.',
  'account.profile.admin.title': 'Admin-Berechtigung',
  'account.profile.admin.text': 'Ist Benutzer Admin?',
  'account.profile.admin_help':
    'Indem Sie dieses Konto zum Admin machen, werden alle Berechtigungsprüfungen umgangen. Darüber hinaus haben nur Admin-Konten die Möglichkeit, andere Konten zu bearbeiten, zu erstellen und zu löschen.',

  'account.password': 'Passwort & Sicherheit',
  'account.password.password': 'Passwort',
  'account.password.change': 'Passwort ändern',
  'account.password.new_field': 'Neues Passwort',
  'account.password.repeat_field': 'Passwort wiederholen',
  'account.password.set_new': 'Neues Passwort festlegen',
  'account.password.passwords_need_to_match': 'Die eingegebenen Passwörter müssen übereinstimmen.',
  'account.password.change_help':
    'Bitte geben Sie Ihr neues Passwort zweimal ein, um sicherzustellen, dass keine Tippfehler vorliegen.',
  'account.password.explain': 'Sie können das Passwort Ihres Kontos jederzeit ändern.',

  'account.experience': 'Erfahrung',
  'account.experience.give_feedback': 'Feedback geben',

  'order.deleted': 'Der Auftrag wurde erfolgreich gelöscht',
  'order.image.upload_failed': 'Bild konnte nicht hochgeladen werden',
  'order.image.invalid_format': 'Ungültiger Dateityp',
  'order.image.too_big': 'Datei größer als 10 MB',

  'order.status': 'Auftragsstatus',
  'order.status.draft': 'Entwurf',
  'order.status.to_be_confirmed': 'Pendent',
  'order.status.confirmed': 'Bestätigt',
  'order.status.running': 'Aktiv',
  'order.status.waiting_to_finish': 'Wird beendet',
  'order.status.finished': 'Beendet',

  'order.chat.no_messages': 'Es gibt noch keine Nachrichten hier.',

  'order.job_posting.retry_btn': 'Wiederholen',
  'order.job_posting.retrying': 'Erneuter Abruf gestartet',
  'order.job_posting.currently_crawling': 'Wir verarbeiten Ihre Stellenanzeige. Bitte haben Sie einen Moment Geduld.',
  'order.job_posting.could_not_crawl': 'Wir konnten Ihre Stellenanzeige nicht automatisch herunterladen.',
  'order.job_posting.could_not_crawl_text': 'Bitte geben Sie den Stellenanzeigentext manuell ein, um fortzufahren.',
  'order.job_posting.placeholder': 'Beginnen Sie mit der Eingabe...',

  'order.job_posting.crawler_status.waiting': 'Warten',
  'order.job_posting.crawler_status.success': 'Erfolgreich',
  'order.job_posting.crawler_status.in_progress': 'In Arbeit',
  'order.job_posting.crawler_status.error': 'Fehler',
  'order.job_posting.crawler_status.blocked': 'Blockiert',
  'order.job_posting.crawler_status.blocked_by_subflow': 'Blockiert durch Unterprozess',
  'order.job_posting.crawler_status.exec_canceled': 'Ausführung abgebrochen',
  'order.job_posting.crawler_status.postpone_scheduled': 'Verschiebung geplant',
  'order.job_posting.crawler_status.postponed': 'Verschoben',
  'order.job_posting.crawler_status.unknown': 'Unbekannter Status',

  'nav.products': 'Produkte',
  'products.title': 'Produkte & Pakete auswählen',
  'products.default': 'Standard',
  'products.modal.budget.title': 'Kampagnenbudget',
  'products.modal.duration.title': 'Laufzeit',
  'products.modal.metric.title': 'Anzahl der Klicks',
  'products.modal.spending.title': 'Ausgaben pro Tag',
  'products.modal.spending.slider.title': 'Ausgaben pro Tag',
  'products.modal.subscription.title': 'Abonnement',
  'products.modal.subscription.confirmation': 'Möchten Sie dieses Abonnement in den Warenkorb legen?',
  'products.modal.splits.title': 'Sub-Budget',
  'products.modal.splits.description': 'Geben Sie an, welchem Sub-Budget dieser Auftrag zugeordnet werden soll.',
  'products.modal.splits.suggesting': 'Beste Übereinstimmung wird gesucht...',
  'products.modal.splits.below_minimum_error': 'Das ausgewählte Budget liegt unter dem Mindestbudget',
  'products.modal.metric.goal.title': 'Anzahl der Klicks',
  'products.modal.options.no_selected': 'Keine Option ausgewählt',
  'products.modal.button.continue': 'In den Warenkorb',
  'nav.billing': 'Budget',
  'nav.billing.budget': 'Budget',
  'nav.billing.splits': 'Sub-Budgets',
  'nav.billing.vbudgets': 'Sub-Budgets',
  'billing.budget.no_budget': 'Es ist kein aktives Budget vorhanden',
  'billing.budget.title': 'Budget & Verträge',
  'billing.budget.manage_virtual_budgets': 'Sub-Budgets verwalten',
  'billing.budget.remaining_card': 'Verbleibendes Budget',
  'billing.budget.spent_of': 'ausgegeben von',
  'billing.budget.consumed': 'verbraucht',
  'billing.budget.allocations_card': 'Zuteilungen / Sub-Budgets',
  'billing.budget.more_allocations': 'mehr Zuteilungen',
  'billing.budget.chart.no_budget': 'Kein Budget',
  'billing.budget.allocations_card.unallocated': 'Nicht zugeordnet',
  'billing.budget.allocations_card.button': 'Sub-Budgets verwalten',
  'billing.budget.budget_tab.contract': 'Vertrag',
  'billing.budget.budget_tab.contact': 'Kontakt',
  'billing.budget.budget_tab.no_contact': 'Kein Kontakt verfügbar',
  'billing.budget.transactions.title': 'Transaktionen',
  'billing.budget.transactions.everything': 'Alles',
  'billing.budget.transactions.withdrawals': 'Belastungen',
  'billing.budget.transactions.deposits': 'Gutschriften',
  'billing.budget.transactions.empty': 'Keine Transaktionen gefunden',

  // Sub-Budgets
  'billing.vbudgets.title': 'Sub-Budgets',
  'billing.vbudgets.available': 'Verfügbar',
  'billing.vbudgets.unallocated': 'Nicht zugeordnet',
  'billing.vbudgets.total_spent': 'Gesamtausgaben',
  'billing.vbudgets.main_budget': 'Hauptbudget',
  'billing.vbudgets.virtual_budget': 'Sub-Budget',
  'billing.vbudgets.create_vbudget': 'Sub-Budget erstellen',
  'billing.vbudgets.select_budget': 'Budget auswählen',
  'billing.vbudgets.select_budget_description':
    'Wählen Sie ein Budget aus der Baumstruktur, um dessen Details anzuzeigen',
  'billing.vbudgets.allocation': 'Zuteilung',
  'billing.vbudgets.spent': 'Ausgegeben',
  'billing.vbudgets.details': 'Details',
  'billing.vbudgets.description': 'Beschreibung',
  'billing.vbudgets.no_description': 'Keine Beschreibung',
  'billing.vbudgets.allocation_type': 'Zuteilungsart',
  'billing.vbudgets.start_date': 'Startdatum',
  'billing.vbudgets.end_date': 'Enddatum',
  'billing.vbudgets.budget_distribution': 'Budgetverteilung',
  'billing.vbudgets.creating_under': 'Erstellen unter',
  'billing.vbudgets.create': 'Erstellen',
  'billing.vbudgets.form.name': 'Name',
  'billing.vbudgets.form.name_placeholder': 'Name des Sub-Budgets eingeben',
  'billing.vbudgets.form.description': 'Beschreibung',
  'billing.vbudgets.form.description_placeholder': 'Optionale Beschreibung',
  'billing.vbudgets.form.allocation': 'Zuteilungsbetrag',
  'billing.vbudgets.form.allocation_placeholder': 'Betrag eingeben',
  'billing.vbudgets.form.allocation_type': 'Zuteilungsart',
  'billing.vbudgets.form.fixed': 'Fester Betrag',
  'billing.vbudgets.form.percentage': 'Prozentsatz',
  'billing.vbudgets.form.start_date': 'Startdatum',
  'billing.vbudgets.form.end_date': 'Enddatum',
  'billing.vbudgets.form.date_range': 'Zeitbereich',
  'billing.vbudgets.form.limit_availability': 'Budgetverfügbarkeit einschränken',
  'billing.vbudgets.form.select_date_range': 'Start- und Enddatum auswählen',
  'billing.vbudgets.form.reference_channels': 'Referenzkanäle',
  'billing.vbudgets.auto_selection': 'Automatische Auswahl',
  'billing.vbudgets.auto_selection_description':
    'Aufträge, die diesen Referenzkanälen entsprechen, werden automatisch diesem Sub-Budget zugeordnet.',
  'billing.vbudgets.error_loading_budget': 'Fehler beim Laden des aktiven Budgets',
  'billing.vbudgets.error_loading_tree': 'Fehler beim Laden der Budgetstruktur',
  'billing.vbudgets.form_validation_error': 'Bitte füllen Sie alle Pflichtfelder aus',
  'billing.vbudgets.created_successfully': 'Sub-Budget erfolgreich erstellt',
  'billing.vbudgets.error_saving': 'Fehler beim Speichern des Sub-Budgets',
  'billing.vbudgets.updated_successfully': 'Sub-Budget erfolgreich aktualisiert',
  'billing.vbudgets.deleted_successfully': 'Sub-Budget erfolgreich gelöscht',
  'billing.vbudgets.error_deleting': 'Fehler beim Löschen des Sub-Budgets',
  'billing.vbudgets.delete_confirm_title': 'Sub-Budget löschen',
  'billing.vbudgets.delete_confirm_description':
    'Sind Sie sicher, dass Sie dieses Sub-Budget löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  'billing.vbudgets.edit_vbudget': 'Sub-Budget bearbeiten',
  'billing.vbudgets.empty_title': 'Noch keine Sub-Budgets',
  'billing.vbudgets.empty_description':
    'Sub-Budgets helfen Ihnen, Ausgaben über Teams oder Kampagnen hinweg zu organisieren und zu verfolgen.',
  'billing.vbudgets.empty_cta': 'Erstes Sub-Budget erstellen',
  'billing.vbudgets.total_budget': 'Gesamtbudget',
  'billing.vbudgets.allocated_label': 'zugeordnet',
  'billing.vbudgets.of_budget_used': 'des Budgets verwendet',
  'billing.vbudgets.remaining_of': '{remaining} von {total} verbleibend',
  'billing.vbudgets.belongs_to': 'Gehört zu',
  'billing.vbudgets.parent_available': 'Im übergeordneten Budget verfügbar',
  'billing.vbudgets.create_child': 'Unter-Budget hinzufügen',
  'billing.vbudgets.col.name': 'Name',
  'billing.vbudgets.col.allocation': 'Zuteilung',
  'billing.vbudgets.col.spent': 'Ausgegeben',
  'billing.vbudgets.col.available': 'Verfügbar',
  'billing.vbudgets.col.usage': 'Nutzung',
  'billing.vbudgets.col.actions': 'Aktionen',
  'billing.vbudgets.sub_budgets': 'Unter-Budgets',
  'billing.vbudgets.no_sub_budgets': 'Noch keine Unter-Budgets erstellt.',
  'billing.vbudgets.tab.details': 'Details',

  'billing.splits.title': 'Sub-Budgets',

  'time.last_month': 'Letzter Monat',
  'time.more_than_two': 'Vor mehr als 2 Monaten',
  'time.more_than_six': 'Vor mehr als 6 Monaten',
  'time.more_than_year': 'Vor über einem Jahr',

  // External Job Markets
  'external_job_markets.title': 'Stellen',
  'external_job_markets.jobs_count': 'Jobs',
  'external_job_markets.last_updated': 'Aktualisiert',
  'external_job_markets.select_datapool': 'Wählen Sie eine Jobbörse aus',
  'external_job_markets.select_datapool_hint': 'Wählen Sie eine der verfügbaren Jobbörsen aus, um die Jobs anzuzeigen',
  'external_job_markets.jobs_for_datapool': 'Jobs für {name}',
  'external_job_markets.search_jobs': 'Jobs durchsuchen',
  'external_job_markets.job_title': 'Jobtitel',
  'external_job_markets.company': 'Unternehmen',
  'external_job_markets.location': 'Standort',
  'external_job_markets.workload': 'Arbeitspensum',
  'external_job_markets.language': 'Sprache',
  'external_job_markets.expires': 'Läuft ab',
  'external_job_markets.view_job': 'Job anzeigen',
  'external_job_markets.create_order': 'Auftrag erstellen',
  'external_job_markets.no_jobs': 'Keine Jobs gefunden',
  'external_job_markets.no_jobs_search': 'Keine Jobs für Ihre Suche gefunden',
  'external_job_markets.no_jobs_hint': 'Diese Jobbörse enthält momentan keine aktiven Jobs',
  'external_job_markets.expires_soon': 'Läuft bald ab',
  'external_job_markets.expired': 'Abgelaufen',
  'external_job_markets.no_applications': 'Keine Bewerbungen',
  'external_job_markets.no_hires': 'Keine Einstellungen',
  'external_job_markets.not_enough_applications': 'Zu wenig Bewerbungen',
  'external_job_markets.filters': 'Filter',
  'external_job_markets.freshness': 'Aktualität',
  'external_job_markets.freshness.today': 'Letzte 24h',
  'external_job_markets.freshness.7days': 'Letzte 7 Tage',
  'external_job_markets.freshness.30days': 'Letzte 30 Tage',
  'external_job_markets.reset_filters': 'Filter zurücksetzen',
  'external_job_markets.loading_jobs': 'Jobs werden geladen...',
  'external_job_markets.job_count_info': '{filtered} von {total} Jobs',
  'external_job_markets.property_filters': 'Eigenschaften',

  'common.back': 'Zurück',

  'channel_references.customer_account': 'Benutzer',
  'channel_references.company': 'Unternehmen',
  'channel_references.product': 'Produkt',
  'channel_references.search_accounts': 'Konten suchen...',
  'channel_references.search_products': 'Produkte suchen...',

  'user_emails_selector.existing_user': 'Bestehender Benutzer',
  'user_emails_selector.insert_email': 'E-Mail eingeben',
  'user_emails_selector.users.placeholder': 'Benutzer auswählen',
  'user_emails_selector.email.placeholder': 'E-Mail-Adresse eingeben',

  'candidate.detail.loading': 'Lade Kandidatendetails...',
  'candidate.detail.unnamed_candidate': 'Unbenannter Kandidat',
  'candidate.detail.load_error': 'Dieser Kandidat konnte nicht geladen werden. Bitte erneut versuchen.',
  'candidate.detail.not_found_title': 'Kandidat nicht gefunden',
  'candidate.detail.not_found_text': 'Dieser Kandidat existiert nicht oder gehört nicht zu Ihrem Konto.',
  'candidate.detail.error_title': 'Dieser Kandidat konnte nicht geladen werden',
  'candidate.detail.retry': 'Erneut versuchen',
  'candidate.detail.no_phone': 'Keine Telefonnummer angegeben',
  'candidate.detail.form_answers': 'Antworten auf Formular-Fragen',
  'candidate.detail.no_answers': 'Für diese Bewerbung wurden keine Formular-Antworten erfasst',
  'candidate.detail.question_column': 'Frage',
  'candidate.detail.answer_column': 'Antwort',
  'candidate.detail.form_events': 'Aktivitätsverlauf',
  'candidate.detail.no_events': 'Für diese Bewerbung wurde keine Aktivität erfasst',
  'candidate.detail.status_history': 'Statusverlauf',
  'candidate.detail.no_status_history': 'Für diese Bewerbung wurden keine Statusänderungen erfasst',
  'candidate.detail.status_change': '{from} → {to}',
  'candidate.detail.status_created': 'Bewerbung erstellt ({status})',
  'candidate.detail.event_form_opened': 'Bewerbungsformular geöffnet',
  'candidate.detail.event_section_viewed': '„{section}“ angesehen',
  'candidate.detail.event_section_answered': '„{section}“ beantwortet',
  'candidate.detail.event_section_back': 'Von „{section}“ zurückgegangen',
  'candidate.detail.applications': 'Bewerbungen',
  'candidate.detail.no_applications': 'Dieser Kandidat hat sich noch auf keinen Auftrag beworben.',
  'candidate.detail.order_label': 'Auftrag #{id}',
  'candidate.detail.publication_label': 'Publikation #{id}',
  'candidate.detail.close_button': 'Schließen',
  'candidate.detail.discard_button': 'Verwerfen',
  'candidate.detail.hire_button': 'Als eingestellt markieren',
  'candidate.detail.close_title': 'Diese Bewerbung schließen?',
  'candidate.detail.close_text': 'Dies verschiebt {name} in die Spalte „Geschlossen“ für Auftrag #{id}.',
  'candidate.detail.close_success': 'Bewerbung geschlossen.',
  'candidate.detail.close_error': 'Diese Bewerbung konnte nicht geschlossen werden. Bitte erneut versuchen.',
  'candidate.detail.discard_title': 'Diese Bewerbung verwerfen?',
  'candidate.detail.discard_text': 'Dies verwirft die Bewerbung von {name} für Auftrag #{id}.',
  'candidate.detail.discard_success': 'Bewerbung verworfen.',
  'candidate.detail.discard_error': 'Diese Bewerbung konnte nicht verworfen werden. Bitte erneut versuchen.',
  'candidate.detail.discard_choice_title': '{name} verwerfen oder löschen?',
  'candidate.detail.discard_choice_text': 'Wählen Sie, wie {name} aus dieser Bewerbung entfernt werden soll.',
  'candidate.detail.discard_option_title': 'Bewerbung verwerfen',
  'candidate.detail.discard_option_text':
    'Entfernt {name} aus der Pipeline für Auftrag #{id}. Der Kandidat bleibt für andere Aufträge und im Kandidatenpool verfügbar.',
  'candidate.detail.full_delete_option_title': 'Vollständig löschen',
  'candidate.detail.full_delete_option_text':
    'Löscht die persönlichen Daten von {name} sowie alle Bewerbungen unwiderruflich. Dies kann nicht rückgängig gemacht werden.',
  'candidate.detail.full_delete_button': 'Vollständig löschen',
  'candidate.detail.full_delete_success': 'Kandidat wurde endgültig gelöscht.',
  'candidate.detail.full_delete_error': 'Dieser Kandidat konnte nicht gelöscht werden. Bitte erneut versuchen.',
  'candidate.detail.hire_title': 'Als eingestellt markieren?',
  'candidate.detail.hire_text': 'Dies verschiebt {name} in die Spalte „Eingestellt“ für Auftrag #{id}.',
  'candidate.detail.hire_success': 'Kandidat als eingestellt markiert.',
  'candidate.detail.hire_error':
    'Dieser Kandidat konnte nicht als eingestellt markiert werden. Bitte erneut versuchen.',
  'candidate.detail.back_to_applications': 'Zurück zu den Kandidaten',
  'candidate.detail.sections': 'Bereiche',
  'candidate.detail.contact': 'Kontakt',
  'candidate.detail.notes': 'Notizen',
  'candidate.detail.files': 'Dateien',
  'candidate.detail.no_files': 'Für diese Bewerbung wurden keine Dateien eingereicht',
  'candidate.detail.file_download_error': 'Diese Datei konnte nicht heruntergeladen werden. Bitte erneut versuchen.',
  'candidate.detail.download_file': 'Herunterladen',
  'candidate.detail.applied_on_label': 'Beworben am',
  'candidate.detail.application_label': 'Bewerbung',
  'candidate.detail.publication_label_short': 'Publikation',
  'candidate.detail.show_more': 'Mehr anzeigen',
  'candidate.detail.show_less': 'Weniger anzeigen',
  'candidate.detail.contact_preference': 'Bevorzugte Kontaktzeit',
  'candidate.detail.no_contact_preference': 'Keine Präferenz angegeben',
  'candidate.detail.contact_time_morning': 'Morgens',
  'candidate.detail.contact_time_midday': 'Mittags',
  'candidate.detail.contact_time_afternoon': 'Nachmittags',
  'candidate.detail.contact_time_evening': 'Abends',

  'candidate.fields.title': 'Zusätzliche Informationen',
  'candidate.fields.empty': 'Für diesen Kandidaten wurden noch keine zusätzlichen Informationen erfasst.',
  'candidate.fields.add_placeholder': 'Feld hinzufügen oder erstellen…',
  'candidate.fields.add_button': 'Feld hinzufügen',
  'candidate.fields.edit': 'Bearbeiten',
  'candidate.fields.clear': 'Wert löschen',
  'candidate.fields.not_set': 'Nicht gesetzt',
  'candidate.fields.save_error': 'Dieses Feld konnte nicht gespeichert werden. Bitte erneut versuchen.',
  'candidate.fields.load_error': 'Die zusätzlichen Informationsfelder konnten nicht geladen werden.',
  'candidate.fields.date_placeholder': 'Datum auswählen',
  'candidate.fields.select_placeholder': 'Option auswählen',
  'candidate.fields.invalid_number': 'Bitte eine Zahl eingeben',
  'candidate.fields.type_text': 'Text',
  'candidate.fields.type_number': 'Zahl',
  'candidate.fields.type_date': 'Datum',
  'candidate.fields.type_select': 'Auswahl',
  'candidate.fields.new.title': 'Neues Feld',
  'candidate.fields.new.description': 'Dieses Feld steht für jeden Kandidaten in Ihrem Konto zur Verfügung.',
  'candidate.fields.new.label': 'Feldname',
  'candidate.fields.new.type': 'Feldtyp',
  'candidate.fields.new.options': 'Optionen',
  'candidate.fields.new.add_option': 'Option hinzufügen',
  'candidate.fields.new.remove_option': 'Option entfernen',
  'candidate.fields.new.create_error': 'Dieses Feld konnte nicht erstellt werden. Bitte erneut versuchen.',
  'candidate.fields.new.create_button': 'Feld erstellen',

  'settings.candidate_fields.title': 'Kandidatenfelder',
  'settings.candidate_fields.subtitle': 'Kandidaten-Informationsfelder erstellen und verwalten',
  'settings.candidate_fields.description':
    'Definieren Sie die zusätzlichen Informationen, die Ihr Team zu Kandidaten erfasst.',
  'settings.candidate_fields.add_button': 'Feld hinzufügen',
  'settings.candidate_fields.edit_title': 'Feld bearbeiten',
  'settings.candidate_fields.usage_count': 'Bei {count} Kandidaten verwendet',
  'settings.candidate_fields.type_locked': 'Der Typ kann nach dem Erstellen des Felds nicht mehr geändert werden',
  'settings.candidate_fields.delete_title': 'Dieses Feld löschen?',
  'settings.candidate_fields.delete_text':
    'Möchten Sie „{name}“ wirklich löschen? Bereits bei Kandidaten erfasste Werte werden ausgeblendet.',
  'settings.candidate_fields.empty': 'Noch keine Kandidatenfelder definiert.',

  // form controls
  'form.password.show': 'Passwort anzeigen',
  'form.password.hide': 'Passwort verbergen',

  // self-registration wizard
  'registration.steps.account': 'Konto erstellen',
  'registration.steps.verify_email': 'E-Mail bestätigen',
  'registration.steps.profile': 'Ihr Profil',
  'registration.steps.company': 'Firmenangaben',
  'registration.steps.goal': 'Ihr Ziel',
  'registration.steps.package': 'Paket wählen',
  'registration.steps.done': 'Fertig',
  'registration.notes.account': 'Dauert etwa eine Minute.',
  'registration.notes.verify_email': 'Der Code kommt innerhalb weniger Sekunden.',
  'registration.notes.company': 'Für den Start genügt der Firmenname.',
  'registration.notes.goal': 'Beeinflusst unsere Empfehlung, ist aber nicht verbindlich.',
  'registration.notes.package': 'Diese Wahl kann später nicht geändert werden.',
  'registration.breadcrumb.step': 'Schritt {current} von {total} · {label}',
  'registration.breadcrumb.complete': 'Einrichtung abgeschlossen',
  'registration.footer.create_account': 'Konto erstellen',
  'registration.footer.continue': 'Weiter',
  'registration.footer.finish_setup': 'Einrichtung abschliessen',
  'registration.sidebar.title': 'In wenigen Minuten zur ersten Kampagne',
  'registration.sidebar.subtitle': 'Sie richten Ihr Konto selbst ein. Kein Verkaufsgespräch, kein Warten.',
  'registration.sidebar.now': 'jetzt',
  'registration.support.name': 'Fragen? Sami hilft.',
  'registration.header.have_account': 'Sie haben schon ein Konto?',
  'registration.footer.back': 'Zurück',
  'registration.footer.do_this_later': 'Später erledigen',
  'registration.step_placeholder': 'Dieser Schritt wird gerade gebaut.',
  // Schritt 1 - Konto erstellen
  'registration.account.title': 'Konto erstellen',
  'registration.account.lede': 'Die Einrichtung ist kostenlos. Sie zahlen pro Kampagne, ab CHF 795.\u2013 pro Stelle.',
  'registration.account.email': 'Gesch\u00e4ftliche E-Mail',
  'registration.account.email_hint': 'Den Best\u00e4tigungscode senden wir im n\u00e4chsten Schritt hierhin.',
  'registration.account.email_invalid': 'Das sieht nicht nach einer E-Mail-Adresse aus.',
  'registration.account.mobile': 'Mobilnummer',
  'registration.account.mobile_hint': 'Zur Best\u00e4tigung Ihres Profils und zur Wiederherstellung Ihres Kontos.',
  'registration.account.mobile_invalid': 'Geben Sie die Mobilnummer an, unter der wir Sie erreichen.',
  'registration.account.mobile_placeholder': '+41 79 123 45 67',
  'registration.account.mobile_unreadable':
    'Geben Sie Ihre Mobilnummer mit L\u00e4ndervorwahl an, z. B. +41 79 123 45 67.',
  'registration.account.password': 'Passwort',
  'registration.account.password_invalid':
    'Mindestens 8 Zeichen, ein Grossbuchstabe und eine Zahl oder ein Sonderzeichen.',
  'registration.account.terms_before': 'Ich akzeptiere die',
  'registration.account.terms': 'Nutzungsbedingungen',
  'registration.account.terms_between': 'und die',
  'registration.account.privacy': 'Datenschutzerkl\u00e4rung',
  'registration.account.terms_after': '.',
  'registration.account.sign_in': 'Anmelden',
  'registration.account.or': 'oder',
  'registration.account.reset_password': 'Passwort zur\u00fccksetzen',
  'registration.account.conflict.email_already_registered': 'F\u00fcr diese Adresse gibt es bereits ein Konto.',
  'registration.account.conflict.registration_in_progress':
    'Mit dieser Adresse haben Sie die Registrierung schon begonnen.',

  // "Passwort festlegen" mitten in der Registrierung, erreicht über den Reset-Link
  'registration.set_password.breadcrumb': 'Passwort festlegen',
  'registration.set_password.title': 'Neues Passwort festlegen',
  'registration.set_password.lede':
    'Wählen Sie ein Passwort, mit dem Sie sich wieder anmelden können. Danach können Sie mit Ihrer Registrierung fortfahren.',
  'registration.set_password.new_password': 'Neues Passwort',
  'registration.set_password.confirm_password': 'Passwort bestätigen',
  'registration.set_password.mismatch': 'Die Passwörter stimmen nicht überein.',
  'registration.set_password.submit': 'Passwort festlegen und fortfahren',

  // Passwortregel des Backends
  'registration.password.rule': 'Mindestens 8 Zeichen, ein Grossbuchstabe und eine Zahl oder ein Sonderzeichen.',
  'registration.password.too_short': 'Zu kurz',
  'registration.password.needs_length': 'Mindestens 8 Zeichen verwenden',
  'registration.password.weak': 'Schwach',
  'registration.password.needs_uppercase': 'Grossbuchstaben hinzuf\u00fcgen',
  'registration.password.almost': 'Fast am Ziel',
  'registration.password.needs_number': 'Zahl oder Sonderzeichen hinzuf\u00fcgen',
  'registration.password.strong': 'Starkes Passwort',

  // Code-Felder für E-Mail und Mobilnummer
  'registration.code.paste_works': 'Den ganzen Code einf\u00fcgen funktioniert',
  'registration.code.resend_in': 'Neu senden in {time}',
  'registration.code.resend': 'Code neu senden',
  'registration.code.resending': 'Wird gesendet\u2026',

  // Schritt 2 - E-Mail bestätigen
  'registration.verify.title': 'E-Mail best\u00e4tigen',
  'registration.verify.lede_before': 'Wir haben einen 6-stelligen Code an',
  'registration.verify.lede_after': 'gesendet. Er l\u00e4uft in {minutes} Minuten ab.',
  'registration.verify.code_label': 'Best\u00e4tigungscode',
  'registration.verify.no_email': 'Nichts im Postfach?',
  'registration.verify.check_spam_before': 'Pr\u00fcfen Sie den Spam-Ordner oder',
  'registration.verify.different_address': 'verwenden Sie eine andere Adresse',
  'registration.verify.check_spam_after': '. Firmenfilter halten die erste Nachricht manchmal zur\u00fcck.',
  'registration.verify.error_incorrect':
    'Dieser Code ist nicht korrekt. Pr\u00fcfen Sie die E-Mail und versuchen Sie es erneut.',
  'registration.verify.error_expired': 'Dieser Code ist abgelaufen. Fordern Sie einen neuen an.',
  'registration.verify.error_too_many': 'Zu viele Versuche mit diesem Code. Fordern Sie einen neuen an.',
  'registration.verify.error_throttled': 'Gerade wurde ein Code gesendet. Warten Sie den Countdown ab.',

  // Schritt 3 - Ihr Profil
  'registration.profile.title': 'Ihr Profil',
  'registration.profile.lede':
    'Bewerberinnen und Bewerber sehen den Namen und das Foto der Person, die die Stelle betreut.',
  'registration.profile.first_name': 'Vorname',
  'registration.profile.last_name': 'Nachname',
  'registration.profile.job_title': 'Funktion (optional)',
  'registration.profile.name_required': 'Ihr Name ist erforderlich, um fortzufahren.',
  'registration.profile.language': 'Bevorzugte Sprache',
  'registration.profile.mobile_title': 'Mobilnummer best\u00e4tigen',
  'registration.profile.mobile_correct': 'Mobilnummer',
  'registration.profile.mobile_pending': 'Ausstehend',
  'registration.profile.mobile_required': 'Best\u00e4tigen Sie Ihre Mobilnummer, um fortzufahren.',
  'registration.profile.mobile_verified': 'Best\u00e4tigt',
  'registration.profile.mobile_sent_to': 'Wir senden einen Code an',
  'registration.profile.mobile_change': 'Nummer \u00e4ndern',
  'registration.profile.mobile_save': 'Speichern',
  'registration.profile.mobile_cancel': 'Abbrechen',
  'registration.profile.mobile_didnt_get': 'Keinen Text erhalten?',
  'registration.profile.mobile_resend': 'Erneut senden',
  'registration.profile.mobile_send': 'Senden',
  'registration.profile.mobile_sending': 'Wird gesendet\u2026',
  'registration.profile.mobile_or': 'oder',
  'registration.profile.mobile_call': 'Code per Anruf vorlesen lassen',
  'registration.profile.mobile_calling': 'Wird angerufen\u2026',
  'registration.profile.code_label': 'Best\u00e4tigungscode',
  'registration.profile.mobile_error_incorrect':
    'Dieser Code ist nicht korrekt. Pr\u00fcfen Sie die SMS und versuchen Sie es erneut.',
  'registration.profile.mobile_error_invalid_phone': 'Diese Mobilnummer ist nicht g\u00fcltig.',
  'registration.profile.mobile_error_delivery_unavailable':
    'An diese Nummer k\u00f6nnen wir im Moment keinen Code senden. Versuchen Sie eine andere Nummer oder wenden Sie sich an den Support.',
  'registration.profile.mobile_error_generic': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',

  // step 4 - company details
  'registration.company.title': 'Firmendaten',
  'registration.company.lede': 'Das erscheint auf Ihren Inseraten und auf Ihren Rechnungen.',
  'registration.company.section_basics': 'Die Grundlagen',
  'registration.company.section_address': 'Adresse und Rechnungsstellung',
  'registration.company.section_brand': 'Marke',
  'registration.company.section_brand_hint':
    'Wird für jedes Inserat verwendet, das wir für Sie erstellen. Sie können das später ändern.',
  'registration.company.name': 'Firmenname',
  'registration.company.careers_page': 'Karriereseite',
  'registration.company.careers_page_hint': 'Wir verlinken Ihre Inserate hierhin.',
  'registration.company.industry': 'Branche',
  'registration.company.industry_placeholder': 'Branche suchen…',
  'registration.company.industry.health': 'Gesundheits- und Sozialwesen',
  'registration.company.industry.trades': 'Bau und Handwerk',
  'registration.company.industry.it': 'IT und Technik',
  'registration.company.industry.retail': 'Handel und Gastgewerbe',
  'registration.company.industry.finance': 'Banken und Versicherungen',
  'registration.company.industry.public': 'Öffentlicher Sektor',
  'registration.company.size': 'Firmengrösse',
  'registration.company.size_placeholder': 'Firmengrösse suchen…',
  'registration.company.size.10': '1–10 Mitarbeitende',
  'registration.company.size.50': '11–50 Mitarbeitende',
  'registration.company.size.200': '51–250 Mitarbeitende',
  'registration.company.size.1000': '251–1000 Mitarbeitende',
  'registration.company.size.1001': 'Mehr als 1000',
  'registration.company.street': 'Strasse und Nummer',
  'registration.company.postcode': 'PLZ',
  'registration.company.city': 'Ort',
  'registration.company.invoice_email': 'Rechnungs-E-Mail',
  'registration.company.uid': 'UID',
  'registration.company.field_required': 'Dieses Feld ist erforderlich.',
  'registration.company.uid_hint': 'z. B. CHE-123.456.789, optional mit MWST/TVA/IVA',
  'registration.company.uid_checking': 'Wird geprüft…',
  'registration.company.uid_confirmed': 'Bestätigt: {name}',
  'registration.company.uid_invalid': 'Geben Sie eine gültige Schweizer UID ein (z. B. CHE-123.456.789).',
  'registration.company.uid_check_unavailable':
    'Wir konnten dies gerade nicht prüfen – es wird geprüft. Sie können fortfahren.',
  'registration.company.address_replace_title': 'Registrierte Adresse übernehmen?',
  'registration.company.address_replace_description':
    'Wir haben diese Adresse im Schweizer Handelsregister gefunden: {address}. Möchten Sie Ihre Eingabe damit ersetzen?',
  'registration.company.address_replace_confirm': 'Adresse übernehmen',
  'registration.company.same_address': 'Die Rechnungsadresse entspricht der Firmenadresse',
  'registration.company.billing_street': 'Rechnungsadresse: Strasse und Nummer',
  'registration.company.billing_postcode': 'Rechnungsadresse: PLZ',
  'registration.company.billing_city': 'Rechnungsadresse: Ort',
  'registration.company.logo': 'Logo',
  'registration.company.logo_drop': 'Datei hierhin ziehen',
  'registration.company.logo_replace': 'Datei ersetzen',
  'registration.company.logo_limit': 'SVG, PNG oder WebP, max. 2 MB',
  'registration.company.logo_uploading': 'Wird hochgeladen…',
  'registration.company.logo_error_type': 'Das Logo muss SVG, PNG oder WebP sein.',
  'registration.company.logo_error_size': 'Das Logo muss kleiner als 2 MB sein.',
  'registration.company.logo_error_svg': 'Die SVG-Datei ist ungültig oder beschädigt.',
  'registration.company.logo_error_upload': 'Das Logo konnte nicht hochgeladen werden. Versuchen Sie es erneut.',
  'registration.company.colours': 'Markenfarben',
  'registration.company.colour_primary': 'Primär',
  'registration.company.colour_accent': 'Akzent',
  'registration.company.colour_pick': 'Farbe wählen',
  'registration.company.colour_remove': 'Diese Farbe entfernen',

  // step 5 - your goal
  'registration.goal.title': 'Wofür stellen Sie ein?',
  'registration.goal.lede':
    'Das beeinflusst die Kanäle, die wir vorschlagen, und das Budget, das wir empfehlen. Nichts davon ist bindend.',
  'registration.goal.main_goal': 'Ihr Hauptziel',
  'registration.goal.main_goal.hard': 'Eine schwer zu besetzende Stelle füllen',
  'registration.goal.main_goal.hard_description': 'Pflege, Handwerk, IT: Es kommen kaum Bewerbungen rein.',
  'registration.goal.main_goal.volume': 'In grösserem Umfang einstellen',
  'registration.goal.main_goal.volume_description': 'Mehrere Stellen mit demselben Profil, das ganze Jahr über.',
  'registration.goal.main_goal.brand': 'Als Arbeitgeber sichtbar sein',
  'registration.goal.main_goal.brand_description': 'Präsent bleiben, bevor Kandidat:innen aktiv zu suchen beginnen.',
  'registration.goal.roles_per_year': 'Stellen, die Sie pro Jahr ausschreiben',
  'registration.goal.roles_per_year_placeholder': 'Stellen pro Jahr auswählen…',
  'registration.goal.roles_per_year.3': '1–3 Stellen',
  'registration.goal.roles_per_year.12': '4–15 Stellen',
  'registration.goal.roles_per_year.40': '16–50 Stellen',
  'registration.goal.roles_per_year.100': 'Mehr als 50',
  'registration.goal.start_window': 'Wann muss die erste Stelle live sein?',
  'registration.goal.start_window_placeholder': 'Zeitfenster auswählen…',
  'registration.goal.start_window.now': 'So schnell wie möglich',
  'registration.goal.start_window.week': 'Innerhalb einer Woche',
  'registration.goal.start_window.month': 'Diesen Monat',
  'registration.goal.start_window.later': 'Ich schaue mich nur um',

  // Schritt 6 - Paket wählen
  'registration.package.title': 'Wie möchten Sie Kampagnen führen?',
  'registration.package.lede':
    'Gleiche Reichweite so oder so. Der Unterschied ist, wer die Arbeit macht, wie schnell ein Inserat live geht und wer das Budget festlegt.',
  'registration.package.note': 'Das legt fest, wie jede Kampagne läuft. Sie können es später nicht mehr ändern.',
  'registration.package.managed.title': '{product} übernimmt das für Sie',
  'registration.package.managed.description':
    'Sie briefen die Stelle in unter einer Minute. Wir schreiben die Inserate, wählen die Kanäle und optimieren, während die Kampagne läuft.',
  'registration.package.managed.price': 'ab CHF 795.– pro Stelle',
  'registration.package.managed.price_note': 'keine monatliche Gebühr',
  'registration.package.managed.pill': 'Meistgewählt',
  'registration.package.managed.benefit_1': 'Bestellung in rund einer Minute aufgegeben',
  'registration.package.managed.benefit_2': 'Text, Creatives und Targeting werden für Sie erledigt',
  'registration.package.managed.benefit_3': 'Kein Marketing-Know-how nötig',
  'registration.package.managed.tradeoff': 'Bis zu 24 Stunden, bis die Kampagne live ist',
  'registration.package.self.title': 'Sie steuern die Kampagne',
  'registration.package.self.description':
    'Legen Sie Targeting und Budget selbst fest, passen Sie die Inserate im Editor an und veröffentlichen Sie, sobald Sie bereit sind. Sie entscheiden, was Ihnen eine Stelle wert ist.',
  'registration.package.self.price': 'ab CHF 290.– pro Auftrag',
  'registration.package.self.price_note': 'Budget legen Sie selbst fest',
  'registration.package.self.benefit_1': 'Sofort veröffentlichen, live in Minuten',
  'registration.package.self.benefit_2': 'Volle Kontrolle über Kanäle und Targeting',
  'registration.package.self.benefit_3': 'Ein laufendes Inserat jederzeit ändern',
  'registration.package.self.tradeoff': 'Sie erstellen und pflegen die Inserate selbst',

  // Schritt 7 - Fertig
  'registration.done.title': 'Ihr Konto ist bereit, {name}',
  'registration.done.lede': '{company} ist eingerichtet. Nächster Halt: Ihre erste Stelle.',
  'registration.done.summary_account': 'Konto',
  'registration.done.summary_package': 'Kampagnenmodus',
  'registration.done.summary_goal': 'Einstellungsziel',
  'registration.done.summary_goal_not_set': 'Noch nicht festgelegt',
  'registration.done.cta_create_campaign': 'Erste Kampagne erstellen',
  'registration.done.cta_dashboard': 'Zum Dashboard',
  'registration.done.retry': 'Erneut versuchen',

  // statt eines Schritts gezeigt, wenn die Registrierung schon abgeschlossen ist
  'registration.finished_elsewhere.title': 'Sie sind bereits eingerichtet',
  'registration.finished_elsewhere.lede':
    'Diese Registrierung wurde bereits abgeschlossen – in einem anderen Tab oder bei einem früheren Besuch. Hier gibt es nichts mehr zu tun.',
  'registration.finished_elsewhere.cta': 'Zum Dashboard',
};
